var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _rect359, _rect360, _rect361, _rect362, _rect363, _rect364, _rect365, _rect366, _rect367, _rect368, _rect369, _rect370, _rect371, _rect372, _rect373, _rect374, _rect375, _rect376, _rect377, _rect378, _rect379, _rect380, _rect381, _rect382, _rect383, _rect384, _rect385, _rect386, _rect387, _rect388, _rect389, _rect390, _rect391, _rect392, _rect393, _rect394, _rect395, _rect396, _rect397, _rect398, _rect399, _rect400, _rect401, _rect402, _rect403, _rect404, _rect405, _rect406, _rect407, _rect408, _rect409, _rect410, _rect411, _rect412, _rect413, _rect414, _rect415, _rect416, _rect417, _rect418, _rect419, _rect420, _rect421, _rect422, _rect423, _rect424, _rect425, _rect426, _rect427, _rect428, _rect429, _rect430, _rect431, _rect432, _rect433, _rect434, _rect435, _rect436, _rect437, _rect438, _rect439, _rect440, _rect441, _rect442, _rect443, _rect444, _rect445, _rect446, _rect447, _rect448, _rect449, _rect450, _rect451, _rect452, _rect453, _rect454, _rect455, _rect456, _rect457, _rect458, _rect459, _rect460, _rect461, _rect462, _rect463, _rect464, _rect465, _rect466, _rect467, _rect468, _rect469, _rect470, _rect471, _rect472, _rect473, _rect474, _rect475, _rect476, _rect477, _rect478, _rect479, _rect480, _rect481, _rect482, _rect483, _rect484, _rect485, _rect486, _rect487, _rect488, _rect489, _rect490, _rect491, _rect492, _rect493, _rect494, _rect495, _rect496, _rect497, _rect498, _rect499, _rect500, _rect501, _rect502, _rect503, _rect504, _rect505, _rect506, _rect507, _rect508, _rect509, _rect510, _rect511, _rect512, _rect513, _rect514, _rect515, _rect516, _rect517, _rect518, _rect519, _rect520, _rect521, _rect522, _rect523, _rect524, _rect525, _rect526, _rect527, _rect528, _rect529, _rect530, _rect531, _rect532, _rect533, _rect534, _rect535, _rect536, _rect537, _rect538, _rect539, _rect540, _rect541, _rect542, _rect543, _rect544, _rect545, _rect546, _rect547, _rect548, _rect549, _rect550, _rect551, _rect552, _rect553, _rect554, _rect555, _rect556, _rect557, _rect558, _rect559, _rect560, _rect561, _rect562, _rect563, _rect564, _rect565, _rect566, _rect567, _rect568, _rect569, _rect570, _rect571, _rect572, _rect573, _rect574, _rect575, _rect576, _rect577, _rect578, _rect579, _rect580, _rect581, _rect582, _rect583, _rect584, _rect585, _rect586, _rect587, _rect588, _rect589, _rect590, _rect591, _rect592, _rect593, _rect594, _rect595, _rect596, _rect597, _rect598, _rect599, _rect600, _rect601, _rect602, _rect603, _rect604, _rect605, _rect606, _rect607, _rect608, _rect609, _rect610, _rect611, _rect612, _rect613, _rect614, _rect615, _rect616, _rect617, _rect618, _rect619, _rect620, _rect621, _rect622, _rect623, _rect624, _rect625, _rect626, _rect627, _rect628, _rect629, _rect630, _rect631, _rect632, _rect633, _rect634, _rect635, _rect636, _rect637, _rect638, _rect639, _rect640, _rect641, _rect642, _rect643, _rect644, _rect645, _rect646, _rect647, _rect648, _rect649, _rect650, _rect651, _rect652, _rect653, _rect654, _rect655, _rect656, _rect657, _rect658, _rect659, _rect660, _rect661, _rect662, _rect663, _rect664, _rect665, _rect666, _rect667, _rect668, _rect669, _rect670, _rect671, _rect672, _rect673, _rect674, _rect675, _rect676, _rect677, _rect678, _rect679, _rect680, _rect681, _rect682, _rect683, _rect684, _rect685, _rect686, _rect687, _rect688, _rect689, _rect690, _rect691, _rect692, _rect693, _rect694, _rect695, _rect696, _rect697, _rect698, _rect699, _rect700, _rect701, _rect702, _rect703, _rect704, _rect705, _rect706, _rect707, _rect708, _rect709, _rect710, _rect711, _rect712, _rect713, _rect714, _rect715, _rect716, _rect717, _rect718, _rect719, _rect720, _rect721, _rect722, _rect723, _rect724, _rect725, _rect726, _rect727, _rect728, _rect729, _rect730, _rect731, _rect732, _rect733, _rect734, _rect735, _rect736, _rect737, _rect738, _rect739, _rect740, _rect741, _rect742, _rect743, _rect744, _rect745, _rect746, _rect747, _rect748, _rect749, _rect750, _rect751, _rect752, _rect753, _rect754, _rect755, _rect756, _rect757, _rect758, _rect759, _rect760, _rect761, _rect762, _rect763, _rect764, _rect765, _rect766, _rect767, _rect768, _rect769, _rect770, _rect771, _rect772, _rect773, _rect774, _rect775, _rect776, _rect777, _rect778, _rect779, _rect780, _rect781, _rect782, _rect783, _rect784, _rect785, _rect786, _rect787, _rect788, _rect789, _rect790, _rect791, _rect792, _rect793, _rect794, _rect795, _rect796, _rect797, _rect798, _rect799, _rect800, _rect801, _rect802, _rect803, _rect804, _rect805, _rect806, _rect807, _rect808, _rect809, _rect810, _rect811, _rect812, _rect813, _rect814, _rect815, _rect816, _rect817, _rect818, _rect819, _rect820, _rect821, _rect822, _rect823, _rect824, _rect825, _rect826, _rect827, _rect828, _rect829, _rect830, _rect831, _rect832, _rect833, _rect834, _rect835, _rect836, _rect837, _rect838, _rect839, _rect840, _rect841, _rect842, _rect843, _rect844, _rect845, _rect846, _rect847, _rect848, _rect849, _rect850, _rect851, _rect852, _rect853, _rect854, _rect855, _rect856, _rect857, _rect858, _rect859, _rect860, _rect861, _rect862, _rect863, _rect864, _rect865, _rect866, _rect867, _rect868, _rect869, _rect870, _rect871, _rect872, _rect873, _rect874, _rect875, _rect876, _rect877, _rect878, _rect879, _rect880, _rect881, _rect882, _rect883, _rect884, _rect885, _rect886, _rect887, _rect888, _rect889, _rect890, _rect891, _rect892, _rect893, _rect894, _rect895, _rect896, _rect897, _rect898, _rect899, _rect900, _rect901, _rect902, _rect903, _rect904, _rect905, _rect906, _rect907, _rect908, _rect909, _rect910, _rect911, _rect912, _rect913, _rect914, _rect915, _rect916, _rect917, _rect918, _rect919, _rect920, _rect921, _rect922, _rect923, _rect924, _rect925, _rect926, _rect927, _rect928, _rect929, _rect930, _rect931, _rect932, _rect933, _rect934, _rect935, _rect936, _rect937, _rect938, _rect939, _rect940, _rect941, _rect942, _rect943, _rect944, _rect945, _rect946, _rect947, _rect948, _rect949, _rect950, _rect951, _rect952, _rect953, _rect954, _rect955, _rect956, _rect957, _rect958, _rect959, _rect960, _rect961, _rect962, _rect963, _rect964, _rect965, _rect966, _rect967, _rect968, _rect969, _rect970, _rect971, _rect972, _rect973, _rect974, _rect975, _rect976, _rect977, _rect978, _rect979, _rect980, _rect981, _rect982, _rect983, _rect984, _rect985, _rect986, _rect987, _rect988, _rect989, _rect990, _rect991, _rect992, _rect993, _rect994, _rect995, _rect996, _rect997, _rect998, _rect999, _rect1000, _rect1001, _rect1002, _rect1003, _rect1004, _rect1005, _rect1006, _rect1007, _rect1008, _rect1009, _rect1010, _rect1011, _rect1012, _rect1013, _rect1014, _rect1015, _rect1016, _rect1017, _rect1018, _rect1019, _rect1020, _rect1021, _rect1022, _rect1023, _rect1024, _rect1025, _rect1026, _rect1027, _rect1028, _rect1029, _rect1030, _rect1031, _rect1032, _rect1033, _rect1034, _rect1035, _rect1036, _rect1037, _rect1038, _rect1039, _rect1040, _rect1041, _rect1042, _rect1043, _rect1044, _rect1045, _rect1046, _rect1047, _rect1048, _rect1049, _rect1050, _rect1051, _rect1052, _rect1053, _rect1054, _rect1055, _rect1056, _rect1057, _rect1058, _rect1059, _rect1060, _rect1061, _rect1062, _rect1063, _rect1064, _rect1065, _rect1066, _rect1067, _rect1068, _rect1069, _rect1070, _rect1071, _rect1072, _rect1073, _rect1074, _rect1075, _rect1076, _rect1077, _rect1078, _rect1079, _rect1080, _rect1081, _rect1082, _rect1083, _rect1084, _rect1085, _rect1086, _rect1087, _rect1088, _rect1089, _rect1090, _rect1091, _rect1092, _rect1093, _rect1094, _rect1095, _rect1096, _rect1097, _rect1098, _rect1099, _rect1100, _rect1101, _rect1102, _rect1103, _rect1104, _rect1105, _rect1106, _rect1107, _rect1108, _rect1109, _rect1110, _rect1111, _rect1112, _rect1113, _rect1114, _rect1115, _rect1116, _rect1117, _rect1118, _rect1119, _rect1120, _rect1121, _rect1122, _rect1123, _rect1124, _rect1125, _rect1126, _rect1127, _rect1128, _rect1129, _rect1130, _rect1131, _rect1132, _rect1133, _rect1134, _rect1135, _rect1136, _rect1137, _rect1138, _rect1139, _rect1140, _rect1141, _rect1142, _rect1143, _rect1144, _rect1145, _rect1146, _rect1147, _rect1148, _rect1149, _rect1150, _rect1151, _rect1152, _rect1153, _rect1154, _rect1155, _rect1156, _rect1157, _rect1158, _rect1159, _rect1160, _rect1161, _rect1162, _rect1163, _rect1164, _rect1165, _rect1166, _rect1167, _rect1168, _rect1169, _rect1170, _rect1171, _rect1172, _rect1173, _rect1174, _rect1175, _rect1176, _rect1177, _rect1178, _rect1179, _rect1180, _rect1181, _rect1182, _rect1183, _rect1184, _rect1185, _rect1186, _rect1187, _rect1188, _rect1189, _rect1190, _rect1191, _rect1192, _rect1193, _rect1194, _rect1195, _rect1196, _rect1197, _rect1198, _rect1199, _rect1200, _rect1201, _rect1202, _rect1203, _rect1204, _rect1205, _rect1206, _rect1207, _rect1208, _rect1209, _rect1210, _rect1211, _rect1212, _rect1213, _rect1214, _rect1215, _rect1216, _rect1217, _rect1218, _rect1219, _rect1220, _rect1221, _rect1222, _rect1223, _rect1224, _rect1225, _rect1226, _rect1227, _rect1228, _rect1229, _rect1230, _rect1231, _rect1232, _rect1233, _rect1234, _rect1235, _rect1236, _rect1237, _rect1238, _rect1239, _rect1240, _rect1241, _rect1242, _rect1243, _rect1244, _rect1245, _rect1246, _rect1247, _rect1248, _rect1249, _rect1250, _rect1251, _rect1252, _rect1253, _rect1254, _rect1255, _rect1256, _rect1257, _rect1258, _rect1259, _rect1260, _rect1261, _rect1262, _rect1263, _rect1264, _rect1265, _rect1266, _rect1267, _rect1268, _rect1269, _rect1270, _rect1271, _rect1272, _rect1273, _rect1274, _rect1275, _rect1276, _rect1277, _rect1278, _rect1279, _rect1280, _rect1281, _rect1282, _rect1283, _rect1284, _rect1285, _rect1286, _rect1287, _rect1288, _rect1289, _rect1290, _rect1291, _rect1292, _rect1293, _rect1294, _rect1295, _rect1296, _rect1297, _rect1298, _rect1299, _rect1300, _rect1301, _rect1302, _rect1303, _rect1304, _rect1305, _rect1306, _rect1307, _rect1308, _rect1309, _rect1310, _rect1311, _rect1312, _rect1313, _rect1314, _rect1315, _rect1316, _rect1317, _rect1318, _rect1319, _rect1320, _rect1321, _rect1322, _rect1323, _rect1324, _rect1325, _rect1326, _rect1327, _rect1328, _rect1329, _rect1330, _rect1331, _rect1332, _rect1333, _rect1334, _rect1335, _rect1336, _rect1337, _rect1338, _rect1339, _rect1340, _rect1341, _rect1342, _rect1343, _rect1344, _rect1345, _rect1346, _rect1347, _rect1348, _rect1349, _rect1350, _rect1351, _rect1352, _rect1353, _rect1354, _rect1355, _rect1356, _rect1357, _rect1358, _rect1359, _rect1360, _rect1361, _rect1362, _rect1363, _rect1364, _rect1365, _rect1366, _rect1367, _rect1368, _rect1369, _rect1370, _rect1371, _rect1372, _rect1373, _rect1374, _rect1375, _rect1376, _rect1377, _rect1378, _rect1379, _rect1380, _rect1381, _rect1382, _rect1383, _rect1384, _rect1385, _rect1386, _rect1387, _rect1388, _rect1389, _rect1390, _rect1391, _rect1392, _rect1393, _rect1394, _rect1395, _rect1396, _rect1397, _rect1398, _rect1399, _rect1400, _rect1401, _rect1402, _rect1403, _rect1404, _rect1405, _rect1406, _rect1407, _rect1408, _rect1409, _rect1410, _rect1411, _rect1412, _rect1413, _rect1414, _rect1415, _rect1416, _rect1417, _rect1418, _rect1419, _rect1420, _rect1421, _rect1422, _rect1423, _rect1424, _rect1425, _rect1426, _rect1427, _rect1428, _rect1429, _rect1430, _rect1431, _rect1432, _rect1433, _rect1434, _rect1435, _rect1436, _rect1437, _rect1438, _rect1439, _rect1440, _rect1441, _rect1442, _rect1443, _rect1444, _rect1445, _rect1446, _rect1447, _rect1448, _rect1449, _rect1450, _rect1451, _rect1452, _rect1453, _rect1454, _rect1455, _rect1456, _rect1457, _rect1458, _rect1459, _rect1460, _rect1461, _rect1462, _rect1463, _rect1464, _rect1465, _rect1466, _rect1467, _rect1468, _rect1469, _rect1470, _rect1471, _rect1472, _rect1473, _rect1474, _rect1475, _rect1476, _rect1477, _rect1478, _rect1479, _rect1480, _rect1481, _rect1482, _rect1483, _rect1484, _rect1485, _rect1486, _rect1487, _rect1488, _rect1489, _rect1490, _rect1491, _rect1492, _rect1493, _rect1494, _rect1495, _rect1496, _rect1497, _rect1498, _rect1499, _rect1500, _rect1501, _rect1502, _rect1503, _rect1504, _rect1505, _rect1506, _rect1507, _rect1508, _rect1509, _rect1510, _rect1511, _rect1512, _rect1513, _rect1514, _rect1515, _rect1516, _rect1517, _rect1518, _rect1519, _rect1520, _rect1521, _rect1522, _rect1523, _rect1524, _rect1525, _rect1526, _rect1527, _rect1528, _rect1529, _rect1530, _rect1531, _rect1532, _rect1533, _rect1534, _rect1535, _rect1536, _rect1537, _rect1538, _rect1539, _rect1540, _rect1541, _rect1542, _rect1543, _rect1544, _rect1545, _rect1546, _rect1547, _rect1548, _rect1549, _rect1550, _rect1551, _rect1552, _rect1553, _rect1554, _rect1555, _rect1556, _rect1557, _rect1558, _rect1559, _rect1560, _rect1561, _rect1562, _rect1563, _rect1564, _rect1565, _rect1566, _rect1567, _rect1568, _rect1569, _rect1570, _rect1571, _rect1572, _rect1573, _rect1574, _rect1575, _rect1576, _rect1577, _rect1578, _rect1579, _rect1580, _rect1581, _rect1582, _rect1583, _rect1584, _rect1585, _rect1586, _rect1587, _rect1588, _rect1589, _rect1590, _rect1591, _rect1592, _rect1593, _rect1594, _rect1595, _rect1596, _rect1597, _rect1598, _rect1599, _rect1600, _rect1601, _rect1602, _rect1603, _rect1604, _rect1605, _rect1606, _rect1607, _rect1608, _rect1609, _rect1610, _rect1611, _rect1612, _rect1613, _rect1614, _rect1615, _rect1616, _rect1617, _rect1618, _rect1619, _rect1620, _rect1621, _rect1622, _rect1623, _rect1624, _rect1625, _rect1626, _rect1627, _rect1628, _rect1629, _rect1630, _rect1631, _rect1632, _rect1633, _rect1634, _rect1635, _rect1636, _rect1637, _rect1638, _rect1639, _rect1640, _rect1641, _rect1642, _rect1643, _rect1644, _rect1645, _rect1646, _rect1647, _rect1648, _rect1649, _rect1650, _rect1651, _rect1652, _rect1653, _rect1654, _rect1655, _rect1656, _rect1657, _rect1658, _rect1659, _rect1660, _rect1661, _rect1662, _rect1663, _rect1664, _rect1665, _rect1666, _rect1667, _rect1668, _rect1669, _rect1670, _rect1671, _rect1672, _rect1673, _rect1674, _rect1675, _rect1676, _rect1677, _rect1678, _rect1679, _rect1680, _rect1681, _rect1682, _rect1683, _rect1684, _rect1685, _rect1686, _rect1687, _rect1688, _rect1689, _rect1690, _rect1691, _rect1692, _rect1693, _rect1694, _rect1695, _rect1696, _rect1697, _rect1698, _rect1699, _rect1700, _rect1701, _rect1702, _rect1703, _rect1704, _rect1705, _rect1706, _rect1707, _rect1708, _rect1709, _rect1710, _rect1711, _rect1712, _rect1713, _rect1714, _rect1715, _rect1716, _rect1717, _rect1718, _rect1719, _rect1720, _rect1721, _rect1722, _rect1723, _rect1724, _rect1725, _rect1726, _rect1727, _rect1728, _rect1729, _rect1730, _rect1731, _rect1732, _rect1733, _rect1734, _rect1735, _rect1736, _rect1737, _rect1738, _rect1739, _rect1740, _rect1741, _rect1742, _rect1743, _rect1744, _rect1745, _rect1746, _rect1747, _rect1748, _rect1749, _rect1750, _rect1751, _rect1752, _rect1753, _rect1754, _rect1755, _rect1756, _rect1757, _rect1758, _rect1759, _rect1760, _rect1761, _rect1762, _rect1763, _rect1764, _rect1765, _rect1766, _rect1767, _rect1768, _rect1769, _rect1770, _rect1771, _rect1772, _rect1773, _rect1774, _rect1775, _rect1776, _rect1777, _rect1778, _rect1779, _rect1780, _rect1781, _rect1782, _rect1783, _rect1784, _rect1785, _rect1786, _rect1787, _rect1788, _rect1789, _rect1790, _rect1791, _rect1792, _rect1793, _rect1794, _rect1795, _rect1796, _rect1797, _rect1798, _rect1799, _rect1800, _rect1801, _rect1802, _rect1803, _rect1804, _rect1805, _rect1806, _rect1807, _rect1808, _rect1809, _rect1810, _rect1811, _rect1812, _rect1813, _rect1814, _rect1815, _rect1816, _rect1817, _rect1818, _rect1819, _rect1820, _rect1821, _rect1822, _rect1823, _rect1824, _rect1825, _rect1826, _rect1827, _rect1828, _rect1829, _rect1830, _rect1831, _rect1832, _rect1833, _rect1834, _rect1835, _rect1836, _rect1837, _rect1838, _rect1839, _rect1840, _rect1841, _rect1842, _rect1843, _rect1844, _rect1845, _rect1846, _rect1847, _rect1848, _rect1849, _rect1850, _rect1851, _rect1852, _rect1853, _rect1854, _rect1855, _rect1856, _rect1857, _rect1858, _rect1859, _rect1860, _rect1861, _rect1862, _rect1863, _rect1864, _rect1865, _rect1866, _rect1867, _rect1868, _rect1869, _rect1870, _rect1871, _rect1872, _rect1873, _rect1874, _rect1875, _rect1876, _rect1877, _rect1878, _rect1879, _rect1880, _rect1881, _rect1882, _rect1883, _rect1884, _rect1885, _rect1886, _rect1887, _rect1888, _rect1889, _rect1890, _rect1891, _rect1892, _rect1893, _rect1894, _rect1895, _rect1896, _rect1897, _rect1898, _rect1899, _rect1900, _rect1901, _rect1902, _rect1903, _rect1904, _rect1905, _rect1906, _rect1907, _rect1908, _rect1909, _rect1910, _rect1911, _rect1912, _rect1913, _rect1914, _rect1915, _rect1916, _rect1917, _rect1918, _rect1919, _rect1920, _rect1921, _rect1922, _rect1923, _rect1924, _rect1925, _rect1926, _rect1927, _rect1928, _rect1929, _rect1930, _rect1931, _rect1932, _rect1933, _rect1934, _rect1935, _rect1936, _rect1937, _rect1938, _rect1939, _rect1940, _rect1941, _rect1942, _rect1943, _rect1944, _rect1945, _rect1946, _rect1947, _rect1948, _rect1949, _rect1950, _rect1951, _rect1952, _rect1953, _rect1954, _rect1955, _rect1956, _rect1957, _rect1958, _rect1959, _rect1960, _rect1961, _rect1962, _rect1963, _rect1964, _rect1965, _rect1966, _rect1967, _rect1968, _rect1969, _rect1970, _rect1971, _rect1972, _rect1973, _rect1974, _rect1975, _rect1976, _rect1977, _rect1978, _rect1979, _rect1980, _rect1981, _rect1982, _rect1983, _rect1984, _rect1985, _rect1986, _rect1987, _rect1988, _rect1989, _rect1990, _rect1991, _rect1992, _rect1993, _rect1994, _rect1995, _rect1996, _rect1997, _rect1998, _rect1999, _rect2000, _rect2001, _rect2002, _rect2003, _rect2004, _rect2005, _rect2006, _rect2007, _rect2008, _rect2009, _rect2010, _rect2011, _rect2012, _rect2013, _rect2014, _rect2015, _rect2016, _rect2017, _rect2018, _rect2019, _rect2020, _rect2021, _rect2022, _rect2023, _rect2024, _rect2025, _rect2026, _rect2027, _rect2028, _rect2029, _rect2030, _rect2031, _rect2032, _rect2033, _rect2034, _rect2035, _rect2036, _rect2037, _rect2038, _rect2039, _rect2040, _rect2041, _rect2042, _rect2043, _rect2044, _rect2045, _rect2046, _rect2047, _rect2048, _rect2049, _rect2050, _rect2051, _rect2052, _rect2053, _rect2054, _rect2055, _rect2056, _rect2057, _rect2058, _rect2059, _rect2060, _rect2061, _rect2062, _rect2063, _rect2064, _rect2065, _rect2066, _rect2067, _rect2068, _rect2069, _rect2070, _rect2071, _rect2072, _rect2073, _rect2074, _rect2075, _rect2076, _rect2077, _rect2078, _rect2079, _rect2080, _rect2081, _rect2082, _rect2083, _rect2084, _rect2085, _rect2086, _rect2087, _rect2088, _rect2089, _rect2090, _rect2091, _rect2092, _rect2093, _rect2094, _rect2095, _rect2096, _rect2097, _rect2098, _rect2099, _rect2100, _rect2101, _rect2102, _rect2103, _rect2104, _rect2105, _rect2106, _rect2107, _rect2108, _rect2109, _rect2110, _rect2111, _rect2112, _rect2113, _rect2114, _rect2115, _rect2116, _rect2117, _rect2118, _rect2119, _rect2120, _rect2121, _rect2122, _rect2123, _rect2124, _rect2125, _rect2126, _rect2127, _rect2128, _rect2129, _rect2130, _rect2131, _rect2132, _rect2133, _rect2134, _rect2135, _rect2136, _rect2137, _rect2138, _rect2139, _rect2140, _rect2141, _rect2142, _rect2143, _rect2144, _rect2145, _rect2146, _rect2147, _rect2148, _rect2149, _rect2150, _rect2151, _rect2152, _rect2153, _rect2154, _rect2155, _rect2156, _rect2157, _rect2158, _rect2159, _rect2160, _rect2161, _rect2162, _rect2163, _rect2164, _rect2165, _rect2166, _rect2167, _rect2168, _rect2169, _rect2170, _rect2171, _rect2172, _rect2173, _rect2174, _rect2175, _rect2176, _rect2177, _rect2178, _rect2179, _rect2180, _rect2181, _rect2182, _rect2183, _rect2184, _rect2185, _rect2186, _rect2187, _rect2188, _rect2189, _rect2190, _rect2191, _rect2192, _rect2193, _rect2194, _rect2195, _rect2196, _rect2197, _rect2198, _rect2199, _rect2200, _rect2201, _rect2202, _rect2203, _rect2204, _rect2205, _rect2206, _rect2207, _rect2208, _rect2209, _rect2210, _rect2211, _rect2212, _rect2213, _rect2214, _rect2215, _rect2216, _rect2217, _rect2218, _rect2219, _rect2220, _rect2221, _rect2222, _rect2223, _rect2224, _rect2225, _rect2226, _rect2227, _rect2228, _rect2229, _rect2230, _rect2231, _rect2232, _rect2233, _rect2234, _rect2235, _rect2236, _rect2237, _rect2238, _rect2239, _rect2240, _rect2241, _rect2242, _rect2243, _rect2244, _rect2245, _rect2246, _rect2247, _rect2248, _rect2249, _rect2250, _rect2251, _rect2252, _rect2253, _rect2254, _rect2255, _rect2256, _rect2257, _rect2258, _rect2259, _rect2260, _rect2261, _rect2262, _rect2263, _rect2264, _rect2265, _rect2266, _rect2267, _rect2268, _rect2269, _rect2270, _rect2271, _rect2272, _rect2273, _rect2274, _rect2275, _rect2276, _rect2277, _rect2278, _rect2279, _rect2280, _rect2281, _rect2282, _rect2283, _rect2284, _rect2285, _rect2286, _rect2287, _rect2288, _rect2289, _rect2290, _rect2291, _rect2292, _rect2293, _rect2294, _rect2295, _rect2296, _rect2297, _rect2298, _rect2299, _rect2300, _rect2301, _rect2302, _rect2303, _rect2304, _rect2305, _rect2306, _rect2307, _rect2308, _rect2309, _rect2310, _rect2311, _rect2312, _rect2313, _rect2314, _rect2315, _rect2316, _rect2317, _rect2318, _rect2319, _rect2320, _rect2321, _rect2322, _rect2323, _rect2324, _rect2325, _rect2326, _rect2327, _rect2328, _rect2329, _rect2330, _rect2331, _rect2332, _rect2333, _rect2334, _rect2335, _rect2336, _rect2337, _rect2338, _rect2339, _rect2340, _rect2341, _rect2342, _rect2343, _rect2344, _rect2345, _rect2346, _rect2347, _rect2348, _rect2349, _rect2350, _rect2351, _rect2352, _rect2353, _rect2354, _rect2355, _rect2356, _rect2357, _rect2358, _rect2359, _rect2360, _rect2361, _rect2362, _rect2363, _rect2364, _rect2365, _rect2366, _rect2367, _rect2368, _rect2369, _rect2370, _rect2371, _rect2372, _rect2373, _rect2374, _rect2375, _rect2376, _rect2377, _rect2378, _rect2379, _rect2380, _rect2381, _rect2382, _rect2383, _rect2384, _rect2385, _rect2386, _rect2387, _rect2388, _rect2389, _rect2390, _rect2391, _rect2392, _rect2393, _rect2394, _rect2395, _rect2396, _rect2397, _rect2398, _rect2399, _rect2400, _rect2401, _rect2402, _rect2403, _rect2404, _rect2405, _rect2406, _rect2407, _rect2408, _rect2409, _rect2410, _rect2411, _rect2412, _rect2413, _rect2414, _rect2415, _rect2416, _rect2417, _rect2418, _rect2419, _rect2420, _rect2421, _rect2422, _rect2423, _rect2424, _rect2425, _rect2426, _rect2427, _rect2428, _rect2429, _rect2430, _rect2431, _rect2432, _rect2433, _rect2434, _rect2435, _rect2436, _rect2437, _rect2438, _rect2439, _rect2440, _rect2441, _rect2442, _rect2443, _rect2444, _rect2445, _rect2446, _rect2447, _rect2448, _rect2449, _rect2450, _rect2451, _rect2452, _rect2453, _rect2454, _rect2455, _rect2456, _rect2457, _rect2458, _rect2459, _rect2460, _rect2461, _rect2462, _rect2463, _rect2464, _rect2465, _rect2466, _rect2467, _rect2468, _rect2469, _rect2470, _rect2471, _rect2472, _rect2473, _rect2474, _rect2475, _rect2476, _rect2477, _rect2478, _rect2479, _rect2480, _rect2481, _rect2482, _rect2483, _rect2484, _rect2485, _rect2486, _rect2487, _rect2488, _rect2489, _rect2490, _rect2491, _rect2492, _rect2493, _rect2494, _rect2495, _rect2496, _rect2497, _rect2498, _rect2499, _rect2500, _rect2501, _rect2502, _rect2503, _rect2504, _rect2505, _rect2506, _rect2507, _rect2508, _rect2509, _rect2510, _rect2511, _rect2512, _rect2513, _rect2514, _rect2515, _rect2516, _rect2517, _rect2518, _rect2519, _rect2520, _rect2521, _rect2522, _rect2523, _rect2524, _rect2525, _rect2526, _rect2527, _rect2528, _rect2529, _rect2530, _rect2531, _rect2532, _rect2533, _rect2534, _rect2535, _rect2536, _rect2537, _rect2538, _rect2539, _rect2540, _rect2541, _rect2542, _rect2543, _rect2544, _rect2545, _rect2546, _rect2547, _rect2548, _rect2549, _rect2550, _rect2551, _rect2552, _rect2553, _rect2554, _rect2555, _rect2556, _rect2557, _rect2558, _rect2559, _rect2560, _rect2561, _rect2562, _rect2563, _rect2564, _rect2565, _rect2566, _rect2567, _rect2568, _rect2569, _rect2570, _rect2571, _rect2572, _rect2573, _rect2574, _rect2575, _rect2576, _rect2577, _rect2578, _rect2579, _rect2580, _rect2581, _rect2582, _rect2583, _rect2584, _rect2585, _rect2586, _rect2587, _rect2588, _rect2589, _rect2590, _rect2591, _rect2592, _rect2593, _rect2594, _rect2595, _rect2596, _rect2597, _rect2598, _rect2599, _rect2600, _rect2601, _rect2602, _rect2603, _rect2604, _rect2605, _rect2606, _rect2607, _rect2608, _rect2609, _rect2610, _rect2611, _rect2612, _rect2613, _rect2614, _rect2615, _rect2616, _rect2617, _rect2618, _rect2619, _rect2620, _rect2621, _rect2622, _rect2623, _rect2624, _rect2625, _rect2626, _rect2627, _rect2628, _rect2629, _rect2630, _rect2631, _rect2632, _rect2633, _rect2634, _rect2635, _rect2636, _rect2637, _rect2638, _rect2639, _rect2640, _rect2641, _rect2642, _rect2643, _rect2644, _rect2645, _rect2646, _rect2647, _rect2648, _rect2649, _rect2650, _rect2651, _rect2652, _rect2653, _rect2654, _rect2655, _rect2656, _rect2657, _rect2658, _rect2659, _rect2660, _rect2661, _rect2662, _rect2663, _rect2664, _rect2665, _rect2666, _rect2667, _rect2668, _rect2669, _rect2670, _rect2671, _rect2672, _rect2673, _rect2674, _rect2675, _rect2676, _rect2677, _rect2678, _rect2679, _rect2680, _rect2681, _rect2682, _rect2683, _rect2684, _rect2685, _rect2686, _rect2687, _rect2688, _rect2689, _rect2690, _rect2691, _rect2692, _rect2693, _rect2694, _rect2695, _rect2696, _rect2697, _rect2698, _rect2699, _rect2700, _rect2701, _rect2702, _rect2703, _rect2704, _rect2705, _rect2706, _rect2707, _rect2708, _rect2709, _rect2710, _rect2711, _rect2712, _rect2713, _rect2714, _rect2715, _rect2716, _rect2717, _rect2718, _rect2719, _rect2720, _rect2721, _rect2722, _rect2723, _rect2724, _rect2725, _rect2726, _rect2727, _rect2728, _rect2729, _rect2730, _rect2731, _rect2732, _rect2733, _rect2734, _rect2735, _rect2736, _rect2737, _rect2738, _rect2739, _rect2740, _rect2741, _rect2742, _rect2743, _rect2744, _rect2745, _rect2746, _rect2747, _rect2748, _rect2749, _rect2750, _rect2751, _rect2752, _rect2753, _rect2754, _rect2755, _rect2756, _rect2757, _rect2758, _rect2759, _rect2760, _rect2761, _rect2762, _rect2763, _rect2764, _rect2765, _rect2766, _rect2767, _rect2768, _rect2769, _rect2770, _rect2771, _rect2772, _rect2773, _rect2774, _rect2775, _rect2776, _rect2777, _rect2778, _rect2779, _rect2780, _rect2781, _rect2782, _rect2783, _rect2784, _rect2785, _rect2786, _rect2787, _rect2788, _rect2789, _rect2790, _rect2791, _rect2792, _rect2793, _rect2794, _rect2795, _rect2796, _rect2797, _rect2798, _rect2799, _rect2800, _rect2801, _rect2802, _rect2803, _rect2804, _rect2805, _rect2806, _rect2807, _rect2808, _rect2809, _rect2810, _rect2811, _rect2812, _rect2813, _rect2814, _rect2815, _rect2816, _rect2817, _rect2818, _rect2819, _rect2820, _rect2821, _rect2822, _rect2823, _rect2824, _rect2825, _rect2826, _rect2827, _rect2828, _rect2829, _rect2830, _rect2831, _rect2832, _rect2833, _rect2834, _rect2835, _rect2836, _rect2837, _rect2838, _rect2839, _rect2840, _rect2841, _rect2842, _rect2843, _rect2844, _rect2845, _rect2846, _rect2847, _rect2848, _rect2849, _rect2850, _rect2851, _rect2852, _rect2853, _rect2854, _rect2855, _rect2856, _rect2857, _rect2858, _rect2859, _rect2860, _rect2861, _rect2862, _rect2863, _rect2864, _rect2865, _rect2866, _rect2867, _rect2868, _rect2869, _rect2870, _rect2871, _rect2872, _rect2873, _rect2874, _rect2875, _rect2876, _rect2877, _rect2878, _rect2879, _rect2880, _rect2881, _rect2882, _rect2883, _rect2884, _rect2885, _rect2886, _rect2887, _rect2888, _rect2889, _rect2890, _rect2891, _rect2892, _rect2893, _rect2894, _rect2895, _rect2896, _rect2897, _rect2898, _rect2899, _rect2900, _rect2901, _rect2902, _rect2903, _rect2904, _rect2905, _rect2906, _rect2907, _rect2908, _rect2909, _rect2910, _rect2911, _rect2912, _rect2913, _rect2914, _rect2915, _rect2916, _rect2917, _rect2918, _rect2919, _rect2920, _rect2921, _rect2922, _rect2923, _rect2924, _rect2925, _rect2926, _rect2927, _rect2928, _rect2929, _rect2930, _rect2931, _rect2932, _rect2933, _rect2934, _rect2935, _rect2936, _rect2937, _rect2938, _rect2939, _rect2940, _rect2941, _rect2942, _rect2943, _rect2944, _rect2945, _rect2946, _rect2947, _rect2948, _rect2949, _rect2950, _rect2951, _rect2952, _rect2953, _rect2954, _rect2955, _rect2956, _rect2957, _rect2958, _rect2959, _rect2960, _rect2961, _rect2962, _rect2963, _rect2964, _rect2965, _rect2966, _rect2967, _rect2968, _rect2969, _rect2970, _rect2971, _rect2972, _rect2973, _rect2974, _rect2975, _rect2976, _rect2977, _rect2978, _rect2979, _rect2980, _rect2981, _rect2982, _rect2983, _rect2984, _rect2985, _rect2986, _rect2987, _rect2988, _rect2989, _rect2990, _rect2991, _rect2992, _rect2993, _rect2994, _rect2995, _rect2996, _rect2997, _rect2998, _rect2999, _rect3000, _rect3001, _rect3002, _rect3003, _rect3004, _rect3005, _rect3006, _rect3007, _rect3008, _rect3009, _rect3010, _rect3011, _rect3012, _rect3013, _rect3014, _rect3015, _rect3016, _rect3017, _rect3018, _rect3019, _rect3020, _rect3021, _rect3022, _rect3023, _rect3024, _rect3025, _rect3026, _rect3027, _rect3028, _rect3029, _rect3030, _rect3031, _rect3032, _rect3033, _rect3034, _rect3035, _rect3036, _rect3037, _rect3038, _rect3039, _rect3040, _rect3041, _rect3042, _rect3043, _rect3044, _rect3045, _rect3046, _rect3047, _rect3048, _rect3049, _rect3050, _rect3051, _rect3052, _rect3053, _rect3054, _rect3055, _rect3056, _rect3057, _rect3058, _rect3059, _rect3060, _rect3061, _rect3062, _rect3063, _rect3064, _rect3065, _rect3066, _rect3067, _rect3068, _rect3069, _rect3070, _rect3071, _rect3072, _rect3073, _rect3074, _rect3075, _rect3076, _rect3077, _rect3078, _rect3079, _rect3080, _rect3081, _rect3082, _rect3083, _rect3084, _rect3085, _rect3086, _rect3087, _rect3088, _rect3089, _rect3090, _rect3091, _rect3092, _rect3093, _rect3094, _rect3095, _rect3096, _rect3097, _rect3098, _rect3099, _rect3100, _rect3101, _rect3102, _rect3103, _rect3104, _rect3105, _rect3106, _rect3107, _rect3108, _rect3109, _rect3110, _rect3111, _rect3112, _rect3113, _rect3114, _rect3115, _rect3116, _rect3117, _rect3118, _rect3119, _rect3120, _rect3121, _rect3122, _rect3123, _rect3124, _rect3125, _rect3126, _rect3127, _rect3128, _rect3129, _rect3130, _rect3131, _rect3132, _rect3133, _rect3134, _rect3135, _rect3136, _rect3137, _rect3138, _rect3139, _rect3140, _rect3141, _rect3142, _rect3143, _rect3144, _rect3145, _rect3146, _rect3147, _rect3148, _rect3149, _rect3150, _rect3151, _rect3152, _rect3153, _rect3154, _rect3155, _rect3156, _rect3157, _rect3158, _rect3159, _rect3160, _rect3161, _rect3162, _rect3163, _rect3164, _rect3165, _rect3166, _rect3167, _rect3168, _rect3169, _rect3170, _rect3171, _rect3172, _rect3173, _rect3174, _rect3175, _rect3176, _rect3177, _rect3178, _rect3179, _rect3180, _rect3181, _rect3182, _rect3183, _rect3184, _rect3185, _rect3186, _rect3187, _rect3188, _rect3189, _rect3190, _rect3191, _rect3192, _rect3193, _rect3194, _rect3195, _rect3196, _rect3197, _rect3198, _rect3199, _rect3200, _rect3201, _rect3202, _rect3203, _rect3204, _rect3205, _rect3206, _rect3207, _rect3208, _rect3209, _rect3210, _rect3211, _rect3212, _rect3213, _rect3214, _rect3215, _rect3216, _rect3217, _rect3218, _rect3219, _rect3220, _rect3221, _rect3222, _rect3223, _rect3224, _rect3225, _rect3226, _rect3227, _rect3228, _rect3229, _rect3230, _rect3231, _rect3232, _rect3233, _rect3234, _rect3235, _rect3236, _rect3237, _rect3238, _rect3239, _rect3240, _rect3241, _rect3242, _rect3243, _rect3244, _rect3245, _rect3246, _rect3247, _rect3248, _rect3249, _rect3250, _rect3251, _rect3252, _rect3253, _rect3254, _rect3255, _rect3256, _rect3257, _rect3258, _rect3259, _rect3260, _rect3261, _rect3262, _rect3263, _rect3264, _rect3265, _rect3266, _rect3267, _rect3268, _rect3269, _rect3270, _rect3271, _rect3272, _rect3273, _rect3274, _rect3275, _rect3276, _rect3277, _rect3278, _rect3279, _rect3280, _rect3281, _rect3282, _rect3283, _rect3284, _rect3285, _rect3286, _rect3287, _rect3288, _rect3289, _rect3290, _rect3291, _rect3292, _rect3293, _rect3294, _rect3295, _rect3296, _rect3297, _rect3298, _rect3299, _rect3300, _rect3301, _rect3302, _rect3303, _rect3304, _rect3305, _rect3306, _rect3307, _rect3308, _rect3309, _rect3310, _rect3311, _rect3312, _rect3313, _rect3314, _rect3315, _rect3316, _rect3317, _rect3318, _rect3319, _rect3320, _rect3321, _rect3322, _rect3323, _rect3324, _rect3325, _rect3326, _rect3327, _rect3328, _rect3329, _rect3330, _rect3331, _rect3332, _rect3333, _rect3334, _rect3335, _rect3336, _rect3337, _rect3338, _rect3339, _rect3340, _rect3341, _rect3342, _rect3343, _rect3344, _rect3345, _rect3346, _rect3347, _rect3348, _rect3349, _rect3350, _rect3351, _rect3352, _rect3353, _rect3354, _rect3355, _rect3356, _rect3357, _rect3358, _rect3359, _rect3360, _rect3361, _rect3362, _rect3363, _rect3364, _rect3365, _rect3366, _rect3367, _rect3368, _rect3369, _rect3370, _rect3371, _rect3372, _rect3373, _rect3374, _rect3375, _rect3376, _rect3377, _rect3378, _rect3379, _rect3380, _rect3381, _rect3382, _rect3383, _rect3384, _rect3385, _rect3386, _rect3387, _rect3388, _rect3389, _rect3390, _rect3391, _rect3392, _rect3393, _rect3394, _rect3395, _rect3396, _rect3397, _rect3398, _rect3399, _rect3400, _rect3401, _rect3402, _rect3403, _rect3404, _rect3405, _rect3406, _rect3407, _rect3408, _rect3409, _rect3410, _rect3411, _rect3412, _rect3413, _rect3414, _rect3415, _rect3416, _rect3417, _rect3418, _rect3419, _rect3420, _rect3421, _rect3422, _rect3423, _rect3424, _rect3425, _rect3426, _rect3427, _rect3428, _rect3429, _rect3430, _rect3431, _rect3432, _rect3433, _rect3434, _rect3435, _rect3436, _rect3437, _rect3438, _rect3439, _rect3440, _rect3441, _rect3442, _rect3443, _rect3444, _rect3445, _rect3446, _rect3447, _rect3448, _rect3449, _rect3450, _rect3451, _rect3452, _rect3453, _rect3454, _rect3455, _rect3456, _rect3457, _rect3458, _rect3459, _rect3460, _rect3461, _rect3462, _rect3463, _rect3464, _rect3465, _rect3466, _rect3467, _rect3468, _rect3469, _rect3470, _rect3471, _rect3472, _rect3473, _rect3474, _rect3475, _rect3476, _rect3477, _rect3478, _rect3479, _rect3480, _rect3481, _rect3482, _rect3483, _rect3484, _rect3485, _rect3486, _rect3487, _rect3488, _rect3489, _rect3490, _rect3491, _rect3492, _rect3493, _rect3494, _rect3495, _rect3496, _rect3497, _rect3498, _rect3499, _rect3500, _rect3501, _rect3502, _rect3503, _rect3504, _rect3505, _rect3506, _rect3507, _rect3508, _rect3509;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCozyHouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 0,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 0,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 0,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 0,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 0,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 0,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 0,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 0,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 0,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 0,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 0,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 0,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 1,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 1,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 1,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 1,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 1,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 1,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 1,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 2,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 2,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 2,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 2,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 2,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 2,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 2,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 2,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 2,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 2,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 3,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 3,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 3,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 3,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 3,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 3,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 4,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 4,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 4,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 4,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 5,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 5,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 5,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 5,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 5,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 5,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 5,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 5,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 5,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 5,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 5,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 5,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 6,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 6,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 6,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 6,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 6,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 6,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 6,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 6,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 6,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 6,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 6,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 6,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 6,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 6,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 6,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 6,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 6,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 6,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 6,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 6,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 6,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 6,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 6,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 6,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 6,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 6,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 6,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 6,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 6,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 6,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 7,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 7,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect377 || (_rect377 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect378 || (_rect378 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect379 || (_rect379 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 7,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect380 || (_rect380 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 7,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect381 || (_rect381 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 7,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect382 || (_rect382 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 7,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect383 || (_rect383 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 7,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect384 || (_rect384 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect385 || (_rect385 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect386 || (_rect386 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect387 || (_rect387 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 7,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect388 || (_rect388 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect389 || (_rect389 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 7,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect390 || (_rect390 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect391 || (_rect391 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect392 || (_rect392 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect393 || (_rect393 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect394 || (_rect394 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect395 || (_rect395 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect396 || (_rect396 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect397 || (_rect397 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 7,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect398 || (_rect398 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect399 || (_rect399 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect400 || (_rect400 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect401 || (_rect401 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect402 || (_rect402 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect403 || (_rect403 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect404 || (_rect404 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect405 || (_rect405 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect406 || (_rect406 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect407 || (_rect407 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 8,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect408 || (_rect408 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect409 || (_rect409 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 8,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect410 || (_rect410 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 8,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect411 || (_rect411 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 8,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect412 || (_rect412 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 8,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect413 || (_rect413 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 8,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect414 || (_rect414 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect415 || (_rect415 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 8,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect416 || (_rect416 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 8,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect417 || (_rect417 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 8,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect418 || (_rect418 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 8,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect419 || (_rect419 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 8,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect420 || (_rect420 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 8,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect421 || (_rect421 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 8,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect422 || (_rect422 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 8,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect423 || (_rect423 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 8,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect424 || (_rect424 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 8,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect425 || (_rect425 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect426 || (_rect426 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect427 || (_rect427 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect428 || (_rect428 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect429 || (_rect429 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect430 || (_rect430 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect431 || (_rect431 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect432 || (_rect432 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect433 || (_rect433 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect434 || (_rect434 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect435 || (_rect435 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect436 || (_rect436 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect437 || (_rect437 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 8,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect438 || (_rect438 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 8,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect439 || (_rect439 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect440 || (_rect440 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect441 || (_rect441 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 8,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect442 || (_rect442 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 8,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect443 || (_rect443 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 8,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect444 || (_rect444 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect445 || (_rect445 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect446 || (_rect446 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect447 || (_rect447 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect448 || (_rect448 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 8,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect449 || (_rect449 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect450 || (_rect450 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 8,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect451 || (_rect451 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect452 || (_rect452 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect453 || (_rect453 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect454 || (_rect454 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect455 || (_rect455 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect456 || (_rect456 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect457 || (_rect457 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 8,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect458 || (_rect458 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect459 || (_rect459 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect460 || (_rect460 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect461 || (_rect461 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect462 || (_rect462 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect463 || (_rect463 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect464 || (_rect464 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect465 || (_rect465 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect466 || (_rect466 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect467 || (_rect467 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect468 || (_rect468 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect469 || (_rect469 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect470 || (_rect470 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect471 || (_rect471 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect472 || (_rect472 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect473 || (_rect473 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect474 || (_rect474 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect475 || (_rect475 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect476 || (_rect476 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect477 || (_rect477 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect478 || (_rect478 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect479 || (_rect479 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect480 || (_rect480 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect481 || (_rect481 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect482 || (_rect482 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect483 || (_rect483 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect484 || (_rect484 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 9,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect485 || (_rect485 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect486 || (_rect486 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect487 || (_rect487 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect488 || (_rect488 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect489 || (_rect489 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect490 || (_rect490 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect491 || (_rect491 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect492 || (_rect492 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect493 || (_rect493 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect494 || (_rect494 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect495 || (_rect495 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect496 || (_rect496 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect497 || (_rect497 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 9,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect498 || (_rect498 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 9,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect499 || (_rect499 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect500 || (_rect500 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect501 || (_rect501 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect502 || (_rect502 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect503 || (_rect503 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect504 || (_rect504 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 9,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect505 || (_rect505 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect506 || (_rect506 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect507 || (_rect507 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect508 || (_rect508 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 9,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect509 || (_rect509 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect510 || (_rect510 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect511 || (_rect511 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect512 || (_rect512 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect513 || (_rect513 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect514 || (_rect514 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect515 || (_rect515 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect516 || (_rect516 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect517 || (_rect517 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect518 || (_rect518 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 9,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect519 || (_rect519 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect520 || (_rect520 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect521 || (_rect521 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect522 || (_rect522 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect523 || (_rect523 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect524 || (_rect524 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect525 || (_rect525 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 10,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect526 || (_rect526 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect527 || (_rect527 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect528 || (_rect528 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect529 || (_rect529 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect530 || (_rect530 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 10,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect531 || (_rect531 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect532 || (_rect532 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect533 || (_rect533 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect534 || (_rect534 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect535 || (_rect535 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect536 || (_rect536 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect537 || (_rect537 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect538 || (_rect538 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect539 || (_rect539 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect540 || (_rect540 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect541 || (_rect541 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect542 || (_rect542 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect543 || (_rect543 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 10,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect544 || (_rect544 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 10,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect545 || (_rect545 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 10,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect546 || (_rect546 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 10,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect547 || (_rect547 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect548 || (_rect548 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect549 || (_rect549 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect550 || (_rect550 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 10,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect551 || (_rect551 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 10,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect552 || (_rect552 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 10,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect553 || (_rect553 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 10,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect554 || (_rect554 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 10,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect555 || (_rect555 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect556 || (_rect556 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect557 || (_rect557 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect558 || (_rect558 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect559 || (_rect559 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect560 || (_rect560 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect561 || (_rect561 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect562 || (_rect562 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect563 || (_rect563 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 10,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect564 || (_rect564 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect565 || (_rect565 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect566 || (_rect566 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect567 || (_rect567 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect568 || (_rect568 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect569 || (_rect569 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect570 || (_rect570 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect571 || (_rect571 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect572 || (_rect572 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 11,
    width: 1,
    height: 1,
    fill: "#FFFFFF"
  })), _rect573 || (_rect573 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect574 || (_rect574 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect575 || (_rect575 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 11,
    width: 1,
    height: 1,
    fill: "#FFFFFF"
  })), _rect576 || (_rect576 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect577 || (_rect577 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 11,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect578 || (_rect578 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect579 || (_rect579 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect580 || (_rect580 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect581 || (_rect581 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect582 || (_rect582 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect583 || (_rect583 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect584 || (_rect584 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect585 || (_rect585 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect586 || (_rect586 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect587 || (_rect587 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect588 || (_rect588 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect589 || (_rect589 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect590 || (_rect590 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 11,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect591 || (_rect591 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect592 || (_rect592 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 11,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect593 || (_rect593 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 11,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect594 || (_rect594 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 11,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect595 || (_rect595 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 11,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect596 || (_rect596 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 11,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect597 || (_rect597 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 11,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect598 || (_rect598 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect599 || (_rect599 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect600 || (_rect600 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 11,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect601 || (_rect601 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 11,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect602 || (_rect602 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect603 || (_rect603 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect604 || (_rect604 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect605 || (_rect605 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect606 || (_rect606 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect607 || (_rect607 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect608 || (_rect608 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect609 || (_rect609 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect610 || (_rect610 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 11,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect611 || (_rect611 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect612 || (_rect612 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect613 || (_rect613 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect614 || (_rect614 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect615 || (_rect615 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect616 || (_rect616 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect617 || (_rect617 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect618 || (_rect618 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect619 || (_rect619 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FFFFFF"
  })), _rect620 || (_rect620 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect621 || (_rect621 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect622 || (_rect622 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FFFFFF"
  })), _rect623 || (_rect623 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 12,
    width: 1,
    height: 1,
    fill: "#FFFFFF"
  })), _rect624 || (_rect624 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect625 || (_rect625 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 12,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect626 || (_rect626 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect627 || (_rect627 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect628 || (_rect628 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect629 || (_rect629 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect630 || (_rect630 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect631 || (_rect631 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect632 || (_rect632 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect633 || (_rect633 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect634 || (_rect634 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect635 || (_rect635 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect636 || (_rect636 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect637 || (_rect637 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect638 || (_rect638 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 12,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect639 || (_rect639 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect640 || (_rect640 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect641 || (_rect641 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect642 || (_rect642 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect643 || (_rect643 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 12,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect644 || (_rect644 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 12,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect645 || (_rect645 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 12,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect646 || (_rect646 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 12,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect647 || (_rect647 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect648 || (_rect648 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 12,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect649 || (_rect649 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 12,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect650 || (_rect650 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect651 || (_rect651 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect652 || (_rect652 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect653 || (_rect653 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect654 || (_rect654 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect655 || (_rect655 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect656 || (_rect656 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect657 || (_rect657 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect658 || (_rect658 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 12,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect659 || (_rect659 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect660 || (_rect660 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect661 || (_rect661 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect662 || (_rect662 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect663 || (_rect663 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect664 || (_rect664 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect665 || (_rect665 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 13,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect666 || (_rect666 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect667 || (_rect667 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FFFFFF"
  })), _rect668 || (_rect668 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect669 || (_rect669 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect670 || (_rect670 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 13,
    width: 1,
    height: 1,
    fill: "#FFFFFF"
  })), _rect671 || (_rect671 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect672 || (_rect672 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 13,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect673 || (_rect673 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect674 || (_rect674 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect675 || (_rect675 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect676 || (_rect676 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect677 || (_rect677 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 13,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect678 || (_rect678 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 13,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect679 || (_rect679 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 13,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect680 || (_rect680 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect681 || (_rect681 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect682 || (_rect682 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect683 || (_rect683 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect684 || (_rect684 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect685 || (_rect685 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 13,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect686 || (_rect686 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 13,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect687 || (_rect687 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect688 || (_rect688 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect689 || (_rect689 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect690 || (_rect690 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect691 || (_rect691 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect692 || (_rect692 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect693 || (_rect693 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect694 || (_rect694 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect695 || (_rect695 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 13,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect696 || (_rect696 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 13,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect697 || (_rect697 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect698 || (_rect698 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect699 || (_rect699 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect700 || (_rect700 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect701 || (_rect701 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect702 || (_rect702 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect703 || (_rect703 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect704 || (_rect704 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect705 || (_rect705 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 13,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect706 || (_rect706 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 14,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect707 || (_rect707 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 14,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect708 || (_rect708 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect709 || (_rect709 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect710 || (_rect710 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 14,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect711 || (_rect711 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 14,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect712 || (_rect712 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 14,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect713 || (_rect713 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect714 || (_rect714 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 14,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect715 || (_rect715 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 14,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect716 || (_rect716 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 14,
    width: 1,
    height: 1,
    fill: "#FFFFFF"
  })), _rect717 || (_rect717 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 14,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect718 || (_rect718 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 14,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect719 || (_rect719 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 14,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect720 || (_rect720 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 14,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect721 || (_rect721 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 14,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect722 || (_rect722 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 14,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect723 || (_rect723 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 14,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect724 || (_rect724 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 14,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect725 || (_rect725 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 14,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect726 || (_rect726 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 14,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect727 || (_rect727 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 14,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect728 || (_rect728 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 14,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect729 || (_rect729 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 14,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect730 || (_rect730 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 14,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect731 || (_rect731 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 14,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect732 || (_rect732 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 14,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect733 || (_rect733 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 14,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect734 || (_rect734 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 14,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect735 || (_rect735 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 14,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect736 || (_rect736 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 14,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect737 || (_rect737 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 14,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect738 || (_rect738 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 14,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect739 || (_rect739 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 14,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect740 || (_rect740 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 14,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect741 || (_rect741 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 14,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect742 || (_rect742 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 14,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect743 || (_rect743 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 14,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect744 || (_rect744 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 14,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect745 || (_rect745 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 14,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect746 || (_rect746 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 14,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect747 || (_rect747 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 14,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect748 || (_rect748 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 14,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect749 || (_rect749 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 14,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect750 || (_rect750 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 14,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect751 || (_rect751 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 14,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect752 || (_rect752 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect753 || (_rect753 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect754 || (_rect754 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect755 || (_rect755 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect756 || (_rect756 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect757 || (_rect757 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect758 || (_rect758 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 15,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect759 || (_rect759 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect760 || (_rect760 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect761 || (_rect761 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect762 || (_rect762 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect763 || (_rect763 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 15,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect764 || (_rect764 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect765 || (_rect765 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect766 || (_rect766 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect767 || (_rect767 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect768 || (_rect768 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect769 || (_rect769 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect770 || (_rect770 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect771 || (_rect771 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect772 || (_rect772 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect773 || (_rect773 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect774 || (_rect774 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect775 || (_rect775 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect776 || (_rect776 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 15,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect777 || (_rect777 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect778 || (_rect778 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect779 || (_rect779 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 15,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect780 || (_rect780 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 15,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect781 || (_rect781 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 15,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect782 || (_rect782 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 15,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect783 || (_rect783 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 15,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect784 || (_rect784 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect785 || (_rect785 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect786 || (_rect786 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect787 || (_rect787 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 15,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect788 || (_rect788 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect789 || (_rect789 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect790 || (_rect790 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect791 || (_rect791 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect792 || (_rect792 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect793 || (_rect793 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect794 || (_rect794 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect795 || (_rect795 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect796 || (_rect796 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 15,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect797 || (_rect797 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect798 || (_rect798 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect799 || (_rect799 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect800 || (_rect800 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect801 || (_rect801 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect802 || (_rect802 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect803 || (_rect803 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 16,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect804 || (_rect804 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect805 || (_rect805 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 16,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect806 || (_rect806 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 16,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect807 || (_rect807 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 16,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect808 || (_rect808 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 16,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect809 || (_rect809 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 16,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect810 || (_rect810 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 16,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect811 || (_rect811 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 16,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect812 || (_rect812 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect813 || (_rect813 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect814 || (_rect814 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect815 || (_rect815 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 16,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect816 || (_rect816 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect817 || (_rect817 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 16,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect818 || (_rect818 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 16,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect819 || (_rect819 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 16,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect820 || (_rect820 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 16,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect821 || (_rect821 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 16,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect822 || (_rect822 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 16,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect823 || (_rect823 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect824 || (_rect824 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 16,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect825 || (_rect825 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect826 || (_rect826 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect827 || (_rect827 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect828 || (_rect828 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect829 || (_rect829 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect830 || (_rect830 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect831 || (_rect831 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect832 || (_rect832 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect833 || (_rect833 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect834 || (_rect834 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect835 || (_rect835 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect836 || (_rect836 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect837 || (_rect837 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 16,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect838 || (_rect838 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 16,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect839 || (_rect839 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect840 || (_rect840 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect841 || (_rect841 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect842 || (_rect842 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 16,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect843 || (_rect843 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 16,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect844 || (_rect844 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 16,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect845 || (_rect845 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect846 || (_rect846 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect847 || (_rect847 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect848 || (_rect848 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 16,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect849 || (_rect849 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect850 || (_rect850 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect851 || (_rect851 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect852 || (_rect852 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect853 || (_rect853 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect854 || (_rect854 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect855 || (_rect855 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect856 || (_rect856 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect857 || (_rect857 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 16,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect858 || (_rect858 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect859 || (_rect859 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect860 || (_rect860 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect861 || (_rect861 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect862 || (_rect862 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect863 || (_rect863 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect864 || (_rect864 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 17,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect865 || (_rect865 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect866 || (_rect866 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect867 || (_rect867 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect868 || (_rect868 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect869 || (_rect869 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect870 || (_rect870 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect871 || (_rect871 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect872 || (_rect872 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect873 || (_rect873 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect874 || (_rect874 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect875 || (_rect875 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect876 || (_rect876 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect877 || (_rect877 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect878 || (_rect878 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect879 || (_rect879 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect880 || (_rect880 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect881 || (_rect881 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect882 || (_rect882 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect883 || (_rect883 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect884 || (_rect884 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect885 || (_rect885 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 17,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect886 || (_rect886 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect887 || (_rect887 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect888 || (_rect888 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect889 || (_rect889 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect890 || (_rect890 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect891 || (_rect891 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect892 || (_rect892 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect893 || (_rect893 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect894 || (_rect894 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect895 || (_rect895 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect896 || (_rect896 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect897 || (_rect897 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect898 || (_rect898 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 17,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect899 || (_rect899 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 17,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect900 || (_rect900 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect901 || (_rect901 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect902 || (_rect902 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect903 || (_rect903 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect904 || (_rect904 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 17,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect905 || (_rect905 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 17,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect906 || (_rect906 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect907 || (_rect907 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect908 || (_rect908 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect909 || (_rect909 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 17,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect910 || (_rect910 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect911 || (_rect911 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect912 || (_rect912 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect913 || (_rect913 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect914 || (_rect914 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect915 || (_rect915 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 17,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect916 || (_rect916 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect917 || (_rect917 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect918 || (_rect918 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect919 || (_rect919 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect920 || (_rect920 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect921 || (_rect921 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect922 || (_rect922 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 18,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect923 || (_rect923 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect924 || (_rect924 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect925 || (_rect925 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect926 || (_rect926 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect927 || (_rect927 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 18,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect928 || (_rect928 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect929 || (_rect929 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect930 || (_rect930 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect931 || (_rect931 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect932 || (_rect932 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect933 || (_rect933 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect934 || (_rect934 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect935 || (_rect935 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect936 || (_rect936 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect937 || (_rect937 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect938 || (_rect938 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect939 || (_rect939 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect940 || (_rect940 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 18,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect941 || (_rect941 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 18,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect942 || (_rect942 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 18,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect943 || (_rect943 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 18,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect944 || (_rect944 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect945 || (_rect945 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect946 || (_rect946 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect947 || (_rect947 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 18,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect948 || (_rect948 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 18,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect949 || (_rect949 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 18,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect950 || (_rect950 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 18,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect951 || (_rect951 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 18,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect952 || (_rect952 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect953 || (_rect953 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect954 || (_rect954 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect955 || (_rect955 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect956 || (_rect956 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect957 || (_rect957 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect958 || (_rect958 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 18,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect959 || (_rect959 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect960 || (_rect960 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect961 || (_rect961 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect962 || (_rect962 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect963 || (_rect963 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect964 || (_rect964 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect965 || (_rect965 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 19,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect966 || (_rect966 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect967 || (_rect967 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 19,
    width: 1,
    height: 1,
    fill: "#FFFFFF"
  })), _rect968 || (_rect968 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect969 || (_rect969 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect970 || (_rect970 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 19,
    width: 1,
    height: 1,
    fill: "#FFFFFF"
  })), _rect971 || (_rect971 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect972 || (_rect972 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 19,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect973 || (_rect973 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect974 || (_rect974 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect975 || (_rect975 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect976 || (_rect976 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect977 || (_rect977 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect978 || (_rect978 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 19,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect979 || (_rect979 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 19,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect980 || (_rect980 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect981 || (_rect981 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect982 || (_rect982 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect983 || (_rect983 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect984 || (_rect984 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect985 || (_rect985 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 19,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect986 || (_rect986 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect987 || (_rect987 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect988 || (_rect988 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 19,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect989 || (_rect989 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 19,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect990 || (_rect990 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 19,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect991 || (_rect991 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 19,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect992 || (_rect992 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 19,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect993 || (_rect993 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 19,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect994 || (_rect994 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect995 || (_rect995 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 19,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect996 || (_rect996 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 19,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect997 || (_rect997 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect998 || (_rect998 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect999 || (_rect999 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1000 || (_rect1000 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1001 || (_rect1001 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1002 || (_rect1002 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1003 || (_rect1003 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 19,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1004 || (_rect1004 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1005 || (_rect1005 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1006 || (_rect1006 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1007 || (_rect1007 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1008 || (_rect1008 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1009 || (_rect1009 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 20,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1010 || (_rect1010 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1011 || (_rect1011 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 20,
    width: 1,
    height: 1,
    fill: "#FFFFFF"
  })), _rect1012 || (_rect1012 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1013 || (_rect1013 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1014 || (_rect1014 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 20,
    width: 1,
    height: 1,
    fill: "#FFFFFF"
  })), _rect1015 || (_rect1015 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1016 || (_rect1016 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 20,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1017 || (_rect1017 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1018 || (_rect1018 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1019 || (_rect1019 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 20,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect1020 || (_rect1020 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 20,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect1021 || (_rect1021 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 20,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect1022 || (_rect1022 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 20,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect1023 || (_rect1023 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 20,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1024 || (_rect1024 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1025 || (_rect1025 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1026 || (_rect1026 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1027 || (_rect1027 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1028 || (_rect1028 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1029 || (_rect1029 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 20,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1030 || (_rect1030 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1031 || (_rect1031 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1032 || (_rect1032 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 20,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1033 || (_rect1033 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 20,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1034 || (_rect1034 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 20,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1035 || (_rect1035 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 20,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1036 || (_rect1036 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 20,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1037 || (_rect1037 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1038 || (_rect1038 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1039 || (_rect1039 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1040 || (_rect1040 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 20,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1041 || (_rect1041 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1042 || (_rect1042 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1043 || (_rect1043 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1044 || (_rect1044 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1045 || (_rect1045 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1046 || (_rect1046 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1047 || (_rect1047 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1048 || (_rect1048 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1049 || (_rect1049 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 20,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1050 || (_rect1050 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 21,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1051 || (_rect1051 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 21,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1052 || (_rect1052 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 21,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1053 || (_rect1053 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 21,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1054 || (_rect1054 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 21,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1055 || (_rect1055 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 21,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1056 || (_rect1056 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 21,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1057 || (_rect1057 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 21,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1058 || (_rect1058 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 21,
    width: 1,
    height: 1,
    fill: "#FFFFFF"
  })), _rect1059 || (_rect1059 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 21,
    width: 1,
    height: 1,
    fill: "#FFFFFF"
  })), _rect1060 || (_rect1060 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 21,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1061 || (_rect1061 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 21,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1062 || (_rect1062 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 21,
    width: 1,
    height: 1,
    fill: "#FFFFFF"
  })), _rect1063 || (_rect1063 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 21,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1064 || (_rect1064 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 21,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1065 || (_rect1065 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 21,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1066 || (_rect1066 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 21,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1067 || (_rect1067 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 21,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1068 || (_rect1068 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 21,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1069 || (_rect1069 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 21,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1070 || (_rect1070 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 21,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1071 || (_rect1071 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 21,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1072 || (_rect1072 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 21,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1073 || (_rect1073 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 21,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1074 || (_rect1074 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 21,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1075 || (_rect1075 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 21,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1076 || (_rect1076 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 21,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1077 || (_rect1077 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 21,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1078 || (_rect1078 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 21,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1079 || (_rect1079 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 21,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1080 || (_rect1080 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 21,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1081 || (_rect1081 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 21,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1082 || (_rect1082 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 21,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1083 || (_rect1083 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 21,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1084 || (_rect1084 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 21,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1085 || (_rect1085 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 21,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1086 || (_rect1086 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 21,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1087 || (_rect1087 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 21,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1088 || (_rect1088 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 21,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1089 || (_rect1089 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 21,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1090 || (_rect1090 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 21,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1091 || (_rect1091 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 21,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1092 || (_rect1092 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 21,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1093 || (_rect1093 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 21,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1094 || (_rect1094 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 21,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1095 || (_rect1095 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 21,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1096 || (_rect1096 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 21,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1097 || (_rect1097 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 21,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1098 || (_rect1098 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1099 || (_rect1099 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1100 || (_rect1100 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1101 || (_rect1101 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1102 || (_rect1102 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 22,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1103 || (_rect1103 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1104 || (_rect1104 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 22,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1105 || (_rect1105 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1106 || (_rect1106 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 22,
    width: 1,
    height: 1,
    fill: "#FFFFFF"
  })), _rect1107 || (_rect1107 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1108 || (_rect1108 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1109 || (_rect1109 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1110 || (_rect1110 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 22,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1111 || (_rect1111 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1112 || (_rect1112 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1113 || (_rect1113 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1114 || (_rect1114 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 22,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1115 || (_rect1115 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1116 || (_rect1116 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1117 || (_rect1117 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1118 || (_rect1118 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1119 || (_rect1119 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 22,
    width: 1,
    height: 1,
    fill: "#8181C2"
  })), _rect1120 || (_rect1120 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 22,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1121 || (_rect1121 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 22,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1122 || (_rect1122 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 22,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1123 || (_rect1123 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 22,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1124 || (_rect1124 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 22,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1125 || (_rect1125 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1126 || (_rect1126 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 22,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1127 || (_rect1127 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1128 || (_rect1128 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1129 || (_rect1129 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1130 || (_rect1130 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1131 || (_rect1131 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1132 || (_rect1132 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1133 || (_rect1133 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 22,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1134 || (_rect1134 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 22,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1135 || (_rect1135 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 22,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1136 || (_rect1136 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 22,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1137 || (_rect1137 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 22,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1138 || (_rect1138 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 22,
    width: 1,
    height: 1,
    fill: "#8181C2"
  })), _rect1139 || (_rect1139 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1140 || (_rect1140 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1141 || (_rect1141 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1142 || (_rect1142 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 22,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1143 || (_rect1143 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 23,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1144 || (_rect1144 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 23,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1145 || (_rect1145 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 23,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1146 || (_rect1146 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 23,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1147 || (_rect1147 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 23,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1148 || (_rect1148 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 23,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1149 || (_rect1149 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 23,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1150 || (_rect1150 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 23,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1151 || (_rect1151 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 23,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect1152 || (_rect1152 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 23,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1153 || (_rect1153 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 23,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1154 || (_rect1154 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 23,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1155 || (_rect1155 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 23,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1156 || (_rect1156 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 23,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1157 || (_rect1157 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 23,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1158 || (_rect1158 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 23,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1159 || (_rect1159 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 23,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1160 || (_rect1160 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 23,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1161 || (_rect1161 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 23,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1162 || (_rect1162 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 23,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1163 || (_rect1163 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 23,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1164 || (_rect1164 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 23,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1165 || (_rect1165 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 23,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1166 || (_rect1166 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 23,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1167 || (_rect1167 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 23,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1168 || (_rect1168 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 23,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect1169 || (_rect1169 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 23,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1170 || (_rect1170 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 23,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1171 || (_rect1171 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 23,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1172 || (_rect1172 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 23,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1173 || (_rect1173 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 23,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1174 || (_rect1174 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 23,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1175 || (_rect1175 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 23,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1176 || (_rect1176 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 23,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1177 || (_rect1177 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 23,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1178 || (_rect1178 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 23,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1179 || (_rect1179 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 23,
    width: 1,
    height: 1,
    fill: "#8181C2"
  })), _rect1180 || (_rect1180 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 23,
    width: 1,
    height: 1,
    fill: "#8181C2"
  })), _rect1181 || (_rect1181 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 23,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1182 || (_rect1182 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 23,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1183 || (_rect1183 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 23,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1184 || (_rect1184 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 23,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1185 || (_rect1185 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 23,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1186 || (_rect1186 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 23,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1187 || (_rect1187 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 23,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1188 || (_rect1188 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 23,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1189 || (_rect1189 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 23,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1190 || (_rect1190 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 23,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1191 || (_rect1191 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 23,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1192 || (_rect1192 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 23,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1193 || (_rect1193 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 23,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1194 || (_rect1194 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 23,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1195 || (_rect1195 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 23,
    width: 1,
    height: 1,
    fill: "#695D97"
  })), _rect1196 || (_rect1196 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 23,
    width: 1,
    height: 1,
    fill: "#8181C2"
  })), _rect1197 || (_rect1197 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 23,
    width: 1,
    height: 1,
    fill: "#8181C2"
  })), _rect1198 || (_rect1198 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 23,
    width: 1,
    height: 1,
    fill: "#8181C2"
  })), _rect1199 || (_rect1199 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 23,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1200 || (_rect1200 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 23,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1201 || (_rect1201 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 23,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1202 || (_rect1202 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 23,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1203 || (_rect1203 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 23,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1204 || (_rect1204 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1205 || (_rect1205 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1206 || (_rect1206 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1207 || (_rect1207 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1208 || (_rect1208 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1209 || (_rect1209 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1210 || (_rect1210 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 24,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1211 || (_rect1211 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1212 || (_rect1212 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 24,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect1213 || (_rect1213 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 24,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1214 || (_rect1214 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1215 || (_rect1215 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1216 || (_rect1216 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1217 || (_rect1217 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1218 || (_rect1218 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1219 || (_rect1219 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1220 || (_rect1220 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1221 || (_rect1221 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1222 || (_rect1222 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1223 || (_rect1223 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1224 || (_rect1224 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 24,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1225 || (_rect1225 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 24,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1226 || (_rect1226 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 24,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1227 || (_rect1227 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1228 || (_rect1228 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 24,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1229 || (_rect1229 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 24,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect1230 || (_rect1230 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1231 || (_rect1231 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 24,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1232 || (_rect1232 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1233 || (_rect1233 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1234 || (_rect1234 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1235 || (_rect1235 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1236 || (_rect1236 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1237 || (_rect1237 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1238 || (_rect1238 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1239 || (_rect1239 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1240 || (_rect1240 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1241 || (_rect1241 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1242 || (_rect1242 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1243 || (_rect1243 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1244 || (_rect1244 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1245 || (_rect1245 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1246 || (_rect1246 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1247 || (_rect1247 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1248 || (_rect1248 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1249 || (_rect1249 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1250 || (_rect1250 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1251 || (_rect1251 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1252 || (_rect1252 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1253 || (_rect1253 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1254 || (_rect1254 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1255 || (_rect1255 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1256 || (_rect1256 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1257 || (_rect1257 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1258 || (_rect1258 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1259 || (_rect1259 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 24,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1260 || (_rect1260 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1261 || (_rect1261 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1262 || (_rect1262 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1263 || (_rect1263 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1264 || (_rect1264 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1265 || (_rect1265 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 24,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1266 || (_rect1266 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1267 || (_rect1267 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1268 || (_rect1268 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1269 || (_rect1269 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1270 || (_rect1270 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1271 || (_rect1271 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1272 || (_rect1272 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 25,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1273 || (_rect1273 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1274 || (_rect1274 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1275 || (_rect1275 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1276 || (_rect1276 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 25,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1277 || (_rect1277 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 25,
    width: 1,
    height: 1,
    fill: "#AEE2FF"
  })), _rect1278 || (_rect1278 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 25,
    width: 1,
    height: 1,
    fill: "#AEE2FF"
  })), _rect1279 || (_rect1279 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 25,
    width: 1,
    height: 1,
    fill: "#AEE2FF"
  })), _rect1280 || (_rect1280 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 25,
    width: 1,
    height: 1,
    fill: "#AEE2FF"
  })), _rect1281 || (_rect1281 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 25,
    width: 1,
    height: 1,
    fill: "#AEE2FF"
  })), _rect1282 || (_rect1282 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 25,
    width: 1,
    height: 1,
    fill: "#AEE2FF"
  })), _rect1283 || (_rect1283 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 25,
    width: 1,
    height: 1,
    fill: "#AEE2FF"
  })), _rect1284 || (_rect1284 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 25,
    width: 1,
    height: 1,
    fill: "#AEE2FF"
  })), _rect1285 || (_rect1285 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 25,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1286 || (_rect1286 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1287 || (_rect1287 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1288 || (_rect1288 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1289 || (_rect1289 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1290 || (_rect1290 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1291 || (_rect1291 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1292 || (_rect1292 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1293 || (_rect1293 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 25,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1294 || (_rect1294 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1295 || (_rect1295 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1296 || (_rect1296 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1297 || (_rect1297 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1298 || (_rect1298 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1299 || (_rect1299 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1300 || (_rect1300 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1301 || (_rect1301 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 25,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1302 || (_rect1302 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 25,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1303 || (_rect1303 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 25,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1304 || (_rect1304 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 25,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1305 || (_rect1305 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 25,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1306 || (_rect1306 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 25,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1307 || (_rect1307 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 25,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1308 || (_rect1308 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 25,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1309 || (_rect1309 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 25,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1310 || (_rect1310 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 25,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1311 || (_rect1311 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 25,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1312 || (_rect1312 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 25,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1313 || (_rect1313 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 25,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1314 || (_rect1314 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 25,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1315 || (_rect1315 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 25,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1316 || (_rect1316 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 25,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1317 || (_rect1317 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 25,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1318 || (_rect1318 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 25,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1319 || (_rect1319 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 25,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1320 || (_rect1320 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 25,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1321 || (_rect1321 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 25,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1322 || (_rect1322 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 25,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1323 || (_rect1323 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 25,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1324 || (_rect1324 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 26,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1325 || (_rect1325 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 26,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1326 || (_rect1326 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 26,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1327 || (_rect1327 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 26,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1328 || (_rect1328 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 26,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1329 || (_rect1329 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 26,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1330 || (_rect1330 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 26,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1331 || (_rect1331 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 26,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1332 || (_rect1332 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 26,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1333 || (_rect1333 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 26,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1334 || (_rect1334 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 26,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1335 || (_rect1335 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 26,
    width: 1,
    height: 1,
    fill: "#AEE2FF"
  })), _rect1336 || (_rect1336 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 26,
    width: 1,
    height: 1,
    fill: "#FCEF8D"
  })), _rect1337 || (_rect1337 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 26,
    width: 1,
    height: 1,
    fill: "#FCEF8D"
  })), _rect1338 || (_rect1338 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 26,
    width: 1,
    height: 1,
    fill: "#FCEF8D"
  })), _rect1339 || (_rect1339 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 26,
    width: 1,
    height: 1,
    fill: "#AEE2FF"
  })), _rect1340 || (_rect1340 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 26,
    width: 1,
    height: 1,
    fill: "#AEE2FF"
  })), _rect1341 || (_rect1341 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 26,
    width: 1,
    height: 1,
    fill: "#AEE2FF"
  })), _rect1342 || (_rect1342 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 26,
    width: 1,
    height: 1,
    fill: "#AEE2FF"
  })), _rect1343 || (_rect1343 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 26,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1344 || (_rect1344 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 26,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1345 || (_rect1345 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 26,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1346 || (_rect1346 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 26,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1347 || (_rect1347 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 26,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1348 || (_rect1348 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 26,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1349 || (_rect1349 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1350 || (_rect1350 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 26,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1351 || (_rect1351 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 26,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1352 || (_rect1352 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 26,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1353 || (_rect1353 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 26,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1354 || (_rect1354 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 26,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1355 || (_rect1355 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 26,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1356 || (_rect1356 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 26,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1357 || (_rect1357 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 26,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1358 || (_rect1358 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 26,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1359 || (_rect1359 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 26,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1360 || (_rect1360 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 26,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1361 || (_rect1361 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 26,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1362 || (_rect1362 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 26,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1363 || (_rect1363 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 26,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1364 || (_rect1364 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 26,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1365 || (_rect1365 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 26,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1366 || (_rect1366 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 26,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1367 || (_rect1367 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 26,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1368 || (_rect1368 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 26,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1369 || (_rect1369 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 26,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1370 || (_rect1370 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 26,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1371 || (_rect1371 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 26,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1372 || (_rect1372 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 26,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1373 || (_rect1373 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 26,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1374 || (_rect1374 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 26,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1375 || (_rect1375 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 26,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1376 || (_rect1376 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 26,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1377 || (_rect1377 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 26,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1378 || (_rect1378 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 26,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1379 || (_rect1379 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 26,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1380 || (_rect1380 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 26,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1381 || (_rect1381 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 26,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1382 || (_rect1382 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 26,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1383 || (_rect1383 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1384 || (_rect1384 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1385 || (_rect1385 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1386 || (_rect1386 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 27,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect1387 || (_rect1387 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 27,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect1388 || (_rect1388 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 27,
    width: 1,
    height: 1,
    fill: "#C97373"
  })), _rect1389 || (_rect1389 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1390 || (_rect1390 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1391 || (_rect1391 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1392 || (_rect1392 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 27,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1393 || (_rect1393 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 27,
    width: 1,
    height: 1,
    fill: "#AEE2FF"
  })), _rect1394 || (_rect1394 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 27,
    width: 1,
    height: 1,
    fill: "#AEE2FF"
  })), _rect1395 || (_rect1395 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 27,
    width: 1,
    height: 1,
    fill: "#F9CD8E"
  })), _rect1396 || (_rect1396 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 27,
    width: 1,
    height: 1,
    fill: "#FCEF8D"
  })), _rect1397 || (_rect1397 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 27,
    width: 1,
    height: 1,
    fill: "#FCEF8D"
  })), _rect1398 || (_rect1398 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 27,
    width: 1,
    height: 1,
    fill: "#FCEF8D"
  })), _rect1399 || (_rect1399 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 27,
    width: 1,
    height: 1,
    fill: "#FCEF8D"
  })), _rect1400 || (_rect1400 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 27,
    width: 1,
    height: 1,
    fill: "#FCEF8D"
  })), _rect1401 || (_rect1401 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 27,
    width: 1,
    height: 1,
    fill: "#FCEF8D"
  })), _rect1402 || (_rect1402 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1403 || (_rect1403 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1404 || (_rect1404 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 27,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1405 || (_rect1405 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1406 || (_rect1406 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1407 || (_rect1407 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1408 || (_rect1408 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1409 || (_rect1409 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1410 || (_rect1410 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1411 || (_rect1411 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1412 || (_rect1412 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1413 || (_rect1413 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1414 || (_rect1414 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1415 || (_rect1415 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1416 || (_rect1416 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1417 || (_rect1417 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 27,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1418 || (_rect1418 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 27,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1419 || (_rect1419 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 27,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1420 || (_rect1420 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 27,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1421 || (_rect1421 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 27,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1422 || (_rect1422 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 27,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1423 || (_rect1423 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 27,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1424 || (_rect1424 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 27,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1425 || (_rect1425 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 27,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1426 || (_rect1426 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 27,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1427 || (_rect1427 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 27,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1428 || (_rect1428 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 27,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1429 || (_rect1429 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 27,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1430 || (_rect1430 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 27,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1431 || (_rect1431 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 27,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1432 || (_rect1432 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 27,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1433 || (_rect1433 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 27,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1434 || (_rect1434 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 27,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1435 || (_rect1435 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 27,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1436 || (_rect1436 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 27,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1437 || (_rect1437 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 27,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1438 || (_rect1438 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 27,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1439 || (_rect1439 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1440 || (_rect1440 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1441 || (_rect1441 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 27,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1442 || (_rect1442 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 28,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1443 || (_rect1443 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 28,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1444 || (_rect1444 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 28,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1445 || (_rect1445 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 28,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1446 || (_rect1446 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 28,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1447 || (_rect1447 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 28,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1448 || (_rect1448 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 28,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1449 || (_rect1449 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 28,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1450 || (_rect1450 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 28,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1451 || (_rect1451 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 28,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1452 || (_rect1452 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 28,
    width: 1,
    height: 1,
    fill: "#AEE2FF"
  })), _rect1453 || (_rect1453 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 28,
    width: 1,
    height: 1,
    fill: "#AEE2FF"
  })), _rect1454 || (_rect1454 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 28,
    width: 1,
    height: 1,
    fill: "#FCEF8D"
  })), _rect1455 || (_rect1455 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 28,
    width: 1,
    height: 1,
    fill: "#F9CD8E"
  })), _rect1456 || (_rect1456 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 28,
    width: 1,
    height: 1,
    fill: "#FCEF8D"
  })), _rect1457 || (_rect1457 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 28,
    width: 1,
    height: 1,
    fill: "#FCEF8D"
  })), _rect1458 || (_rect1458 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 28,
    width: 1,
    height: 1,
    fill: "#FCEF8D"
  })), _rect1459 || (_rect1459 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 28,
    width: 1,
    height: 1,
    fill: "#F9CD8E"
  })), _rect1460 || (_rect1460 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 28,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1461 || (_rect1461 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 28,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1462 || (_rect1462 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 28,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1463 || (_rect1463 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 28,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1464 || (_rect1464 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 28,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1465 || (_rect1465 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 28,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1466 || (_rect1466 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 28,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1467 || (_rect1467 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 28,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1468 || (_rect1468 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1469 || (_rect1469 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 28,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1470 || (_rect1470 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 28,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1471 || (_rect1471 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 28,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1472 || (_rect1472 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 28,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1473 || (_rect1473 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 28,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1474 || (_rect1474 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 28,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1475 || (_rect1475 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 28,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1476 || (_rect1476 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 28,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1477 || (_rect1477 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 28,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1478 || (_rect1478 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 28,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1479 || (_rect1479 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 28,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1480 || (_rect1480 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 28,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1481 || (_rect1481 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 28,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1482 || (_rect1482 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 28,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1483 || (_rect1483 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 28,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1484 || (_rect1484 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 28,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1485 || (_rect1485 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 28,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1486 || (_rect1486 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 28,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1487 || (_rect1487 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 28,
    width: 1,
    height: 1,
    fill: "#F49373"
  })), _rect1488 || (_rect1488 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 28,
    width: 1,
    height: 1,
    fill: "#F49373"
  })), _rect1489 || (_rect1489 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 28,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1490 || (_rect1490 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 28,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1491 || (_rect1491 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 28,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1492 || (_rect1492 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 28,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1493 || (_rect1493 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 28,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1494 || (_rect1494 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 28,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1495 || (_rect1495 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 28,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1496 || (_rect1496 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 28,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1497 || (_rect1497 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 28,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1498 || (_rect1498 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 28,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1499 || (_rect1499 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 28,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1500 || (_rect1500 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 29,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1501 || (_rect1501 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 29,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1502 || (_rect1502 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 29,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1503 || (_rect1503 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 29,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1504 || (_rect1504 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 29,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1505 || (_rect1505 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 29,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1506 || (_rect1506 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 29,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1507 || (_rect1507 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 29,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1508 || (_rect1508 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 29,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1509 || (_rect1509 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 29,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1510 || (_rect1510 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 29,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1511 || (_rect1511 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 29,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1512 || (_rect1512 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 29,
    width: 1,
    height: 1,
    fill: "#FCEF8D"
  })), _rect1513 || (_rect1513 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 29,
    width: 1,
    height: 1,
    fill: "#FCEF8D"
  })), _rect1514 || (_rect1514 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 29,
    width: 1,
    height: 1,
    fill: "#FCEF8D"
  })), _rect1515 || (_rect1515 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 29,
    width: 1,
    height: 1,
    fill: "#FCEF8D"
  })), _rect1516 || (_rect1516 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 29,
    width: 1,
    height: 1,
    fill: "#FCEF8D"
  })), _rect1517 || (_rect1517 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 29,
    width: 1,
    height: 1,
    fill: "#FCEF8D"
  })), _rect1518 || (_rect1518 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 29,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1519 || (_rect1519 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 29,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1520 || (_rect1520 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 29,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1521 || (_rect1521 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 29,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1522 || (_rect1522 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 29,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1523 || (_rect1523 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 29,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1524 || (_rect1524 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 29,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1525 || (_rect1525 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 29,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1526 || (_rect1526 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 29,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1527 || (_rect1527 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 29,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1528 || (_rect1528 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 29,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1529 || (_rect1529 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 29,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1530 || (_rect1530 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 29,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1531 || (_rect1531 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 29,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1532 || (_rect1532 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 29,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1533 || (_rect1533 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 29,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1534 || (_rect1534 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 29,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1535 || (_rect1535 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 29,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1536 || (_rect1536 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 29,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1537 || (_rect1537 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 29,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1538 || (_rect1538 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 29,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1539 || (_rect1539 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 29,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1540 || (_rect1540 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 29,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1541 || (_rect1541 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 29,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1542 || (_rect1542 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 29,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1543 || (_rect1543 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 29,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1544 || (_rect1544 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 29,
    width: 1,
    height: 1,
    fill: "#F49373"
  })), _rect1545 || (_rect1545 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 29,
    width: 1,
    height: 1,
    fill: "#F49373"
  })), _rect1546 || (_rect1546 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    width: 1,
    height: 1,
    fill: "#F49373"
  })), _rect1547 || (_rect1547 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 29,
    width: 1,
    height: 1,
    fill: "#F49373"
  })), _rect1548 || (_rect1548 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 29,
    width: 1,
    height: 1,
    fill: "#F49373"
  })), _rect1549 || (_rect1549 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 29,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1550 || (_rect1550 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 29,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1551 || (_rect1551 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 29,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1552 || (_rect1552 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 29,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1553 || (_rect1553 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 29,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1554 || (_rect1554 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 29,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1555 || (_rect1555 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 29,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1556 || (_rect1556 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 29,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1557 || (_rect1557 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 29,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1558 || (_rect1558 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 29,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1559 || (_rect1559 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1560 || (_rect1560 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1561 || (_rect1561 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1562 || (_rect1562 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 30,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1563 || (_rect1563 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1564 || (_rect1564 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1565 || (_rect1565 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1566 || (_rect1566 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1567 || (_rect1567 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1568 || (_rect1568 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1569 || (_rect1569 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1570 || (_rect1570 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1571 || (_rect1571 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 30,
    width: 1,
    height: 1,
    fill: "#F9CD8E"
  })), _rect1572 || (_rect1572 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 30,
    width: 1,
    height: 1,
    fill: "#FCEF8D"
  })), _rect1573 || (_rect1573 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 30,
    width: 1,
    height: 1,
    fill: "#FCEF8D"
  })), _rect1574 || (_rect1574 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 30,
    width: 1,
    height: 1,
    fill: "#FCEF8D"
  })), _rect1575 || (_rect1575 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 30,
    width: 1,
    height: 1,
    fill: "#F9CD8E"
  })), _rect1576 || (_rect1576 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 30,
    width: 1,
    height: 1,
    fill: "#F9CD8E"
  })), _rect1577 || (_rect1577 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 30,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1578 || (_rect1578 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1579 || (_rect1579 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1580 || (_rect1580 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1581 || (_rect1581 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1582 || (_rect1582 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1583 || (_rect1583 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1584 || (_rect1584 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1585 || (_rect1585 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1586 || (_rect1586 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1587 || (_rect1587 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1588 || (_rect1588 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1589 || (_rect1589 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 30,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1590 || (_rect1590 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1591 || (_rect1591 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1592 || (_rect1592 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1593 || (_rect1593 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1594 || (_rect1594 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 30,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1595 || (_rect1595 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 30,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1596 || (_rect1596 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 30,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1597 || (_rect1597 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 30,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1598 || (_rect1598 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 30,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1599 || (_rect1599 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 30,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1600 || (_rect1600 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 30,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1601 || (_rect1601 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 30,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1602 || (_rect1602 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 30,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1603 || (_rect1603 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 30,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1604 || (_rect1604 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 30,
    width: 1,
    height: 1,
    fill: "#F49373"
  })), _rect1605 || (_rect1605 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 30,
    width: 1,
    height: 1,
    fill: "#F49373"
  })), _rect1606 || (_rect1606 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 30,
    width: 1,
    height: 1,
    fill: "#F49373"
  })), _rect1607 || (_rect1607 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 30,
    width: 1,
    height: 1,
    fill: "#F49373"
  })), _rect1608 || (_rect1608 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 30,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1609 || (_rect1609 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 30,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1610 || (_rect1610 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 30,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1611 || (_rect1611 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 30,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1612 || (_rect1612 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 30,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1613 || (_rect1613 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 30,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1614 || (_rect1614 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 30,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1615 || (_rect1615 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 30,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1616 || (_rect1616 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1617 || (_rect1617 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1618 || (_rect1618 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 30,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1619 || (_rect1619 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1620 || (_rect1620 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1621 || (_rect1621 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 31,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1622 || (_rect1622 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1623 || (_rect1623 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1624 || (_rect1624 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1625 || (_rect1625 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1626 || (_rect1626 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1627 || (_rect1627 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1628 || (_rect1628 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1629 || (_rect1629 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1630 || (_rect1630 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 31,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1631 || (_rect1631 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 31,
    width: 1,
    height: 1,
    fill: "#F9CD8E"
  })), _rect1632 || (_rect1632 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 31,
    width: 1,
    height: 1,
    fill: "#F9CD8E"
  })), _rect1633 || (_rect1633 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 31,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1634 || (_rect1634 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 31,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1635 || (_rect1635 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 31,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1636 || (_rect1636 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 31,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1637 || (_rect1637 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1638 || (_rect1638 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 31,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1639 || (_rect1639 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1640 || (_rect1640 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1641 || (_rect1641 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1642 || (_rect1642 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1643 || (_rect1643 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1644 || (_rect1644 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1645 || (_rect1645 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1646 || (_rect1646 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1647 || (_rect1647 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 31,
    width: 1,
    height: 1,
    fill: "#BDBDB5"
  })), _rect1648 || (_rect1648 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 31,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1649 || (_rect1649 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1650 || (_rect1650 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1651 || (_rect1651 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1652 || (_rect1652 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1653 || (_rect1653 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 31,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1654 || (_rect1654 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 31,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1655 || (_rect1655 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 31,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1656 || (_rect1656 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 31,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1657 || (_rect1657 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 31,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1658 || (_rect1658 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 31,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1659 || (_rect1659 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 31,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1660 || (_rect1660 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 31,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1661 || (_rect1661 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 31,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1662 || (_rect1662 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 31,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1663 || (_rect1663 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 31,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1664 || (_rect1664 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 31,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1665 || (_rect1665 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 31,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1666 || (_rect1666 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 31,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1667 || (_rect1667 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 31,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1668 || (_rect1668 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 31,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1669 || (_rect1669 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 31,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1670 || (_rect1670 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 31,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1671 || (_rect1671 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 31,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1672 || (_rect1672 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 31,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1673 || (_rect1673 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 31,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1674 || (_rect1674 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 31,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1675 || (_rect1675 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1676 || (_rect1676 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1677 || (_rect1677 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1678 || (_rect1678 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 31,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1679 || (_rect1679 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1680 || (_rect1680 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1681 || (_rect1681 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 32,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1682 || (_rect1682 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1683 || (_rect1683 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1684 || (_rect1684 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1685 || (_rect1685 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1686 || (_rect1686 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1687 || (_rect1687 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1688 || (_rect1688 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1689 || (_rect1689 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1690 || (_rect1690 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1691 || (_rect1691 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 32,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1692 || (_rect1692 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 32,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1693 || (_rect1693 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 32,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1694 || (_rect1694 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 32,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1695 || (_rect1695 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 32,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1696 || (_rect1696 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1697 || (_rect1697 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 32,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1698 || (_rect1698 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 32,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1699 || (_rect1699 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 32,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1700 || (_rect1700 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 32,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1701 || (_rect1701 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 32,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1702 || (_rect1702 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1703 || (_rect1703 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1704 || (_rect1704 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1705 || (_rect1705 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1706 || (_rect1706 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1707 || (_rect1707 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 32,
    width: 1,
    height: 1,
    fill: "#BDBDB5"
  })), _rect1708 || (_rect1708 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 32,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1709 || (_rect1709 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1710 || (_rect1710 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1711 || (_rect1711 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1712 || (_rect1712 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1713 || (_rect1713 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 32,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1714 || (_rect1714 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 32,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1715 || (_rect1715 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 32,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1716 || (_rect1716 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 32,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1717 || (_rect1717 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 32,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1718 || (_rect1718 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 32,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1719 || (_rect1719 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 32,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1720 || (_rect1720 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 32,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1721 || (_rect1721 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 32,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1722 || (_rect1722 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 32,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1723 || (_rect1723 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 32,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1724 || (_rect1724 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 32,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1725 || (_rect1725 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 32,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1726 || (_rect1726 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 32,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1727 || (_rect1727 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 32,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1728 || (_rect1728 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 32,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1729 || (_rect1729 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 32,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1730 || (_rect1730 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 32,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1731 || (_rect1731 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 32,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1732 || (_rect1732 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 32,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1733 || (_rect1733 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 32,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1734 || (_rect1734 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 32,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1735 || (_rect1735 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1736 || (_rect1736 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1737 || (_rect1737 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1738 || (_rect1738 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 32,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1739 || (_rect1739 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1740 || (_rect1740 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1741 || (_rect1741 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 33,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1742 || (_rect1742 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1743 || (_rect1743 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1744 || (_rect1744 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1745 || (_rect1745 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1746 || (_rect1746 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1747 || (_rect1747 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1748 || (_rect1748 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 33,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1749 || (_rect1749 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 33,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1750 || (_rect1750 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 33,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1751 || (_rect1751 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1752 || (_rect1752 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 33,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1753 || (_rect1753 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 33,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1754 || (_rect1754 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 33,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1755 || (_rect1755 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1756 || (_rect1756 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 33,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1757 || (_rect1757 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 33,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1758 || (_rect1758 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 33,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1759 || (_rect1759 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 33,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1760 || (_rect1760 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 33,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1761 || (_rect1761 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 33,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1762 || (_rect1762 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1763 || (_rect1763 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1764 || (_rect1764 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1765 || (_rect1765 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1766 || (_rect1766 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1767 || (_rect1767 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 33,
    width: 1,
    height: 1,
    fill: "#BDBDB5"
  })), _rect1768 || (_rect1768 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1769 || (_rect1769 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1770 || (_rect1770 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1771 || (_rect1771 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1772 || (_rect1772 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1773 || (_rect1773 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 33,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1774 || (_rect1774 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 33,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1775 || (_rect1775 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 33,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1776 || (_rect1776 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 33,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1777 || (_rect1777 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 33,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1778 || (_rect1778 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 33,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1779 || (_rect1779 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 33,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1780 || (_rect1780 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 33,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1781 || (_rect1781 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 33,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1782 || (_rect1782 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 33,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1783 || (_rect1783 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 33,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1784 || (_rect1784 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 33,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1785 || (_rect1785 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 33,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1786 || (_rect1786 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 33,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1787 || (_rect1787 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 33,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect1788 || (_rect1788 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 33,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1789 || (_rect1789 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 33,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1790 || (_rect1790 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 33,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1791 || (_rect1791 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 33,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1792 || (_rect1792 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 33,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1793 || (_rect1793 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 33,
    width: 1,
    height: 1,
    fill: "#5B4180"
  })), _rect1794 || (_rect1794 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 33,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1795 || (_rect1795 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1796 || (_rect1796 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1797 || (_rect1797 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 33,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1798 || (_rect1798 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 34,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1799 || (_rect1799 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 34,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1800 || (_rect1800 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1801 || (_rect1801 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1802 || (_rect1802 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1803 || (_rect1803 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1804 || (_rect1804 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1805 || (_rect1805 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1806 || (_rect1806 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 34,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1807 || (_rect1807 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 34,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1808 || (_rect1808 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 34,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1809 || (_rect1809 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 34,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1810 || (_rect1810 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1811 || (_rect1811 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1812 || (_rect1812 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1813 || (_rect1813 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 34,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1814 || (_rect1814 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 34,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1815 || (_rect1815 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1816 || (_rect1816 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 34,
    width: 1,
    height: 1,
    fill: "#F2AE99"
  })), _rect1817 || (_rect1817 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1818 || (_rect1818 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1819 || (_rect1819 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1820 || (_rect1820 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1821 || (_rect1821 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1822 || (_rect1822 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1823 || (_rect1823 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1824 || (_rect1824 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1825 || (_rect1825 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 34,
    width: 1,
    height: 1,
    fill: "#BDBDB5"
  })), _rect1826 || (_rect1826 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1827 || (_rect1827 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1828 || (_rect1828 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 34,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1829 || (_rect1829 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 34,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1830 || (_rect1830 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 34,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1831 || (_rect1831 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 34,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1832 || (_rect1832 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 34,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1833 || (_rect1833 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 34,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1834 || (_rect1834 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 34,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1835 || (_rect1835 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 34,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1836 || (_rect1836 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 34,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1837 || (_rect1837 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 34,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1838 || (_rect1838 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1839 || (_rect1839 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 34,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1840 || (_rect1840 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 34,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1841 || (_rect1841 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 34,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1842 || (_rect1842 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 34,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1843 || (_rect1843 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 34,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1844 || (_rect1844 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 34,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1845 || (_rect1845 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 34,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1846 || (_rect1846 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 34,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1847 || (_rect1847 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 34,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect1848 || (_rect1848 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 34,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1849 || (_rect1849 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 34,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1850 || (_rect1850 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 34,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1851 || (_rect1851 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 34,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1852 || (_rect1852 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 34,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1853 || (_rect1853 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1854 || (_rect1854 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1855 || (_rect1855 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 34,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1856 || (_rect1856 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1857 || (_rect1857 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1858 || (_rect1858 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 35,
    width: 1,
    height: 1,
    fill: "#879B76"
  })), _rect1859 || (_rect1859 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1860 || (_rect1860 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1861 || (_rect1861 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1862 || (_rect1862 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1863 || (_rect1863 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1864 || (_rect1864 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1865 || (_rect1865 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1866 || (_rect1866 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1867 || (_rect1867 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 35,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1868 || (_rect1868 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 35,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1869 || (_rect1869 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 35,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1870 || (_rect1870 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 35,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1871 || (_rect1871 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 35,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1872 || (_rect1872 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 35,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1873 || (_rect1873 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect1874 || (_rect1874 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1875 || (_rect1875 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1876 || (_rect1876 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1877 || (_rect1877 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 35,
    width: 1,
    height: 1,
    fill: "#BDBDB5"
  })), _rect1878 || (_rect1878 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 35,
    width: 1,
    height: 1,
    fill: "#BDBDB5"
  })), _rect1879 || (_rect1879 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1880 || (_rect1880 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1881 || (_rect1881 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1882 || (_rect1882 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 35,
    width: 1,
    height: 1,
    fill: "#BDBDB5"
  })), _rect1883 || (_rect1883 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 35,
    width: 1,
    height: 1,
    fill: "#BDBDB5"
  })), _rect1884 || (_rect1884 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 35,
    width: 1,
    height: 1,
    fill: "#BDBDB5"
  })), _rect1885 || (_rect1885 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A2A78C"
  })), _rect1886 || (_rect1886 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1887 || (_rect1887 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1888 || (_rect1888 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1889 || (_rect1889 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1890 || (_rect1890 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 35,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1891 || (_rect1891 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 35,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1892 || (_rect1892 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 35,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect1893 || (_rect1893 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 35,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1894 || (_rect1894 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 35,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1895 || (_rect1895 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 35,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1896 || (_rect1896 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1897 || (_rect1897 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 35,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1898 || (_rect1898 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 35,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1899 || (_rect1899 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 35,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1900 || (_rect1900 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 35,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1901 || (_rect1901 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 35,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1902 || (_rect1902 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 35,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1903 || (_rect1903 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 35,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1904 || (_rect1904 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 35,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1905 || (_rect1905 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 35,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect1906 || (_rect1906 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 35,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1907 || (_rect1907 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 35,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1908 || (_rect1908 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 35,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1909 || (_rect1909 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 35,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect1910 || (_rect1910 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 35,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1911 || (_rect1911 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 35,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1912 || (_rect1912 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1913 || (_rect1913 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1914 || (_rect1914 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1915 || (_rect1915 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1916 || (_rect1916 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 35,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1917 || (_rect1917 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 36,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1918 || (_rect1918 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 36,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1919 || (_rect1919 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 36,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect1920 || (_rect1920 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 36,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1921 || (_rect1921 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 36,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1922 || (_rect1922 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 36,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1923 || (_rect1923 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 36,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1924 || (_rect1924 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 36,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1925 || (_rect1925 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 36,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1926 || (_rect1926 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 36,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1927 || (_rect1927 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 36,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1928 || (_rect1928 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 36,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1929 || (_rect1929 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 36,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1930 || (_rect1930 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 36,
    width: 1,
    height: 1,
    fill: "#8DB7FF"
  })), _rect1931 || (_rect1931 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 36,
    width: 1,
    height: 1,
    fill: "#8DB7FF"
  })), _rect1932 || (_rect1932 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 36,
    width: 1,
    height: 1,
    fill: "#8DB7FF"
  })), _rect1933 || (_rect1933 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 36,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect1934 || (_rect1934 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 36,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1935 || (_rect1935 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 36,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1936 || (_rect1936 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 36,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1937 || (_rect1937 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 36,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1938 || (_rect1938 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 36,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1939 || (_rect1939 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 36,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1940 || (_rect1940 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 36,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1941 || (_rect1941 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 36,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1942 || (_rect1942 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 36,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1943 || (_rect1943 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 36,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1944 || (_rect1944 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 36,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1945 || (_rect1945 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 36,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1946 || (_rect1946 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 36,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1947 || (_rect1947 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 36,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1948 || (_rect1948 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 36,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1949 || (_rect1949 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 36,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1950 || (_rect1950 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1951 || (_rect1951 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 36,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1952 || (_rect1952 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 36,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1953 || (_rect1953 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 36,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect1954 || (_rect1954 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 36,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1955 || (_rect1955 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1956 || (_rect1956 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 36,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1957 || (_rect1957 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 36,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1958 || (_rect1958 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 36,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1959 || (_rect1959 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 36,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1960 || (_rect1960 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 36,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1961 || (_rect1961 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 36,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1962 || (_rect1962 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 36,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1963 || (_rect1963 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 36,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1964 || (_rect1964 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 36,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1965 || (_rect1965 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 36,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1966 || (_rect1966 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 36,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1967 || (_rect1967 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 36,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1968 || (_rect1968 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 36,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1969 || (_rect1969 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 36,
    width: 1,
    height: 1,
    fill: "#390947"
  })), _rect1970 || (_rect1970 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 36,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect1971 || (_rect1971 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 36,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect1972 || (_rect1972 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 36,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect1973 || (_rect1973 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 36,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1974 || (_rect1974 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 36,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1975 || (_rect1975 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 36,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1976 || (_rect1976 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 36,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1977 || (_rect1977 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 37,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect1978 || (_rect1978 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 37,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect1979 || (_rect1979 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 37,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect1980 || (_rect1980 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 37,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1981 || (_rect1981 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 37,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1982 || (_rect1982 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 37,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1983 || (_rect1983 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 37,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1984 || (_rect1984 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 37,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1985 || (_rect1985 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 37,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1986 || (_rect1986 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 37,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1987 || (_rect1987 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 37,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1988 || (_rect1988 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 37,
    width: 1,
    height: 1,
    fill: "#8DB7FF"
  })), _rect1989 || (_rect1989 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 37,
    width: 1,
    height: 1,
    fill: "#6D80FA"
  })), _rect1990 || (_rect1990 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 37,
    width: 1,
    height: 1,
    fill: "#6D80FA"
  })), _rect1991 || (_rect1991 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 37,
    width: 1,
    height: 1,
    fill: "#6D80FA"
  })), _rect1992 || (_rect1992 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 37,
    width: 1,
    height: 1,
    fill: "#8DB7FF"
  })), _rect1993 || (_rect1993 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 37,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1994 || (_rect1994 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 37,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1995 || (_rect1995 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 37,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1996 || (_rect1996 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 37,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1997 || (_rect1997 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 37,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1998 || (_rect1998 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 37,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect1999 || (_rect1999 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 37,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect2000 || (_rect2000 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 37,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect2001 || (_rect2001 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 37,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect2002 || (_rect2002 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 37,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect2003 || (_rect2003 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 37,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect2004 || (_rect2004 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 37,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect2005 || (_rect2005 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 37,
    width: 1,
    height: 1,
    fill: "#678E70"
  })), _rect2006 || (_rect2006 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 37,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2007 || (_rect2007 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 37,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2008 || (_rect2008 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 37,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2009 || (_rect2009 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 37,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2010 || (_rect2010 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 37,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect2011 || (_rect2011 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 37,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2012 || (_rect2012 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 37,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2013 || (_rect2013 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 37,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2014 || (_rect2014 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 37,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2015 || (_rect2015 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 37,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2016 || (_rect2016 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 37,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2017 || (_rect2017 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 37,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2018 || (_rect2018 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 37,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2019 || (_rect2019 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 37,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2020 || (_rect2020 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 37,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2021 || (_rect2021 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 37,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2022 || (_rect2022 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 37,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2023 || (_rect2023 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 37,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2024 || (_rect2024 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 37,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2025 || (_rect2025 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 37,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2026 || (_rect2026 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 37,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2027 || (_rect2027 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 37,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2028 || (_rect2028 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 37,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2029 || (_rect2029 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 37,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2030 || (_rect2030 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 37,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2031 || (_rect2031 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 37,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect2032 || (_rect2032 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 37,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2033 || (_rect2033 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 37,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2034 || (_rect2034 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 37,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2035 || (_rect2035 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 37,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2036 || (_rect2036 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2037 || (_rect2037 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2038 || (_rect2038 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2039 || (_rect2039 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2040 || (_rect2040 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 38,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2041 || (_rect2041 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 38,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2042 || (_rect2042 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 38,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2043 || (_rect2043 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2044 || (_rect2044 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2045 || (_rect2045 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2046 || (_rect2046 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2047 || (_rect2047 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 38,
    width: 1,
    height: 1,
    fill: "#5B5BEC"
  })), _rect2048 || (_rect2048 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 38,
    width: 1,
    height: 1,
    fill: "#6D80FA"
  })), _rect2049 || (_rect2049 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 38,
    width: 1,
    height: 1,
    fill: "#6D80FA"
  })), _rect2050 || (_rect2050 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 38,
    width: 1,
    height: 1,
    fill: "#6D80FA"
  })), _rect2051 || (_rect2051 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 38,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2052 || (_rect2052 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 38,
    width: 1,
    height: 1,
    fill: "#6D80FA"
  })), _rect2053 || (_rect2053 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 38,
    width: 1,
    height: 1,
    fill: "#5B5BEC"
  })), _rect2054 || (_rect2054 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2055 || (_rect2055 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2056 || (_rect2056 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2057 || (_rect2057 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2058 || (_rect2058 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2059 || (_rect2059 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2060 || (_rect2060 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2061 || (_rect2061 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 38,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2062 || (_rect2062 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 38,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2063 || (_rect2063 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 38,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2064 || (_rect2064 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2065 || (_rect2065 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2066 || (_rect2066 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2067 || (_rect2067 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2068 || (_rect2068 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2069 || (_rect2069 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2070 || (_rect2070 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 38,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect2071 || (_rect2071 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 38,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2072 || (_rect2072 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 38,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2073 || (_rect2073 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 38,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2074 || (_rect2074 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 38,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2075 || (_rect2075 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 38,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2076 || (_rect2076 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 38,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2077 || (_rect2077 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 38,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2078 || (_rect2078 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 38,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2079 || (_rect2079 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 38,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2080 || (_rect2080 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 38,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2081 || (_rect2081 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 38,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2082 || (_rect2082 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 38,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2083 || (_rect2083 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2084 || (_rect2084 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 38,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2085 || (_rect2085 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 38,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2086 || (_rect2086 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 38,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2087 || (_rect2087 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 38,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2088 || (_rect2088 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 38,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2089 || (_rect2089 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 38,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2090 || (_rect2090 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 38,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2091 || (_rect2091 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 38,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect2092 || (_rect2092 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2093 || (_rect2093 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2094 || (_rect2094 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2095 || (_rect2095 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 38,
    width: 1,
    height: 1,
    fill: "#A6555F"
  })), _rect2096 || (_rect2096 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2097 || (_rect2097 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2098 || (_rect2098 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2099 || (_rect2099 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2100 || (_rect2100 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 39,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2101 || (_rect2101 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 39,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2102 || (_rect2102 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 39,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2103 || (_rect2103 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2104 || (_rect2104 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2105 || (_rect2105 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2106 || (_rect2106 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2107 || (_rect2107 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 39,
    width: 1,
    height: 1,
    fill: "#5B5BEC"
  })), _rect2108 || (_rect2108 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 39,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2109 || (_rect2109 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 39,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2110 || (_rect2110 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 39,
    width: 1,
    height: 1,
    fill: "#6D80FA"
  })), _rect2111 || (_rect2111 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 39,
    width: 1,
    height: 1,
    fill: "#6D80FA"
  })), _rect2112 || (_rect2112 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 39,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2113 || (_rect2113 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 39,
    width: 1,
    height: 1,
    fill: "#5B5BEC"
  })), _rect2114 || (_rect2114 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2115 || (_rect2115 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2116 || (_rect2116 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2117 || (_rect2117 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2118 || (_rect2118 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2119 || (_rect2119 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2120 || (_rect2120 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2121 || (_rect2121 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 39,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2122 || (_rect2122 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 39,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2123 || (_rect2123 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 39,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2124 || (_rect2124 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2125 || (_rect2125 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2126 || (_rect2126 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2127 || (_rect2127 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2128 || (_rect2128 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2129 || (_rect2129 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2130 || (_rect2130 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 39,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect2131 || (_rect2131 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 39,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2132 || (_rect2132 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 39,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2133 || (_rect2133 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 39,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2134 || (_rect2134 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 39,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2135 || (_rect2135 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 39,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2136 || (_rect2136 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 39,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2137 || (_rect2137 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 39,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2138 || (_rect2138 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 39,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2139 || (_rect2139 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 39,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2140 || (_rect2140 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 39,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2141 || (_rect2141 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 39,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2142 || (_rect2142 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 39,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2143 || (_rect2143 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 39,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2144 || (_rect2144 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 39,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2145 || (_rect2145 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 39,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2146 || (_rect2146 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 39,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2147 || (_rect2147 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 39,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2148 || (_rect2148 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 39,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2149 || (_rect2149 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 39,
    width: 1,
    height: 1,
    fill: "#5A3271"
  })), _rect2150 || (_rect2150 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 39,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2151 || (_rect2151 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 39,
    width: 1,
    height: 1,
    fill: "#611851"
  })), _rect2152 || (_rect2152 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2153 || (_rect2153 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2154 || (_rect2154 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2155 || (_rect2155 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 39,
    width: 1,
    height: 1,
    fill: "#873555"
  })), _rect2156 || (_rect2156 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2157 || (_rect2157 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2158 || (_rect2158 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2159 || (_rect2159 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2160 || (_rect2160 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 40,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2161 || (_rect2161 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 40,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2162 || (_rect2162 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 40,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2163 || (_rect2163 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2164 || (_rect2164 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2165 || (_rect2165 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2166 || (_rect2166 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2167 || (_rect2167 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 40,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2168 || (_rect2168 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 40,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2169 || (_rect2169 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 40,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2170 || (_rect2170 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 40,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2171 || (_rect2171 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 40,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2172 || (_rect2172 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 40,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2173 || (_rect2173 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 40,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2174 || (_rect2174 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2175 || (_rect2175 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2176 || (_rect2176 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2177 || (_rect2177 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2178 || (_rect2178 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2179 || (_rect2179 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2180 || (_rect2180 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2181 || (_rect2181 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 40,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2182 || (_rect2182 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 40,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2183 || (_rect2183 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 40,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2184 || (_rect2184 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2185 || (_rect2185 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2186 || (_rect2186 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2187 || (_rect2187 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2188 || (_rect2188 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2189 || (_rect2189 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2190 || (_rect2190 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2191 || (_rect2191 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2192 || (_rect2192 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2193 || (_rect2193 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2194 || (_rect2194 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2195 || (_rect2195 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2196 || (_rect2196 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2197 || (_rect2197 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2198 || (_rect2198 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2199 || (_rect2199 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2200 || (_rect2200 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2201 || (_rect2201 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2202 || (_rect2202 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2203 || (_rect2203 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2204 || (_rect2204 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2205 || (_rect2205 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2206 || (_rect2206 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2207 || (_rect2207 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2208 || (_rect2208 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2209 || (_rect2209 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2210 || (_rect2210 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4C245A"
  })), _rect2211 || (_rect2211 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2212 || (_rect2212 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2213 || (_rect2213 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2214 || (_rect2214 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 40,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2215 || (_rect2215 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2216 || (_rect2216 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2217 || (_rect2217 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2218 || (_rect2218 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2219 || (_rect2219 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 41,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2220 || (_rect2220 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 41,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2221 || (_rect2221 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 41,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2222 || (_rect2222 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 41,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2223 || (_rect2223 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 41,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2224 || (_rect2224 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 41,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2225 || (_rect2225 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 41,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2226 || (_rect2226 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 41,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2227 || (_rect2227 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 41,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2228 || (_rect2228 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 41,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2229 || (_rect2229 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 41,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2230 || (_rect2230 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 41,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2231 || (_rect2231 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 41,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2232 || (_rect2232 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 41,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2233 || (_rect2233 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 41,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2234 || (_rect2234 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 41,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2235 || (_rect2235 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 41,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2236 || (_rect2236 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 41,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2237 || (_rect2237 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 41,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2238 || (_rect2238 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 41,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2239 || (_rect2239 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 41,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2240 || (_rect2240 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 41,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2241 || (_rect2241 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 41,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2242 || (_rect2242 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 41,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2243 || (_rect2243 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 41,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2244 || (_rect2244 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 41,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2245 || (_rect2245 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2246 || (_rect2246 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2247 || (_rect2247 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2248 || (_rect2248 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2249 || (_rect2249 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2250 || (_rect2250 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2251 || (_rect2251 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2252 || (_rect2252 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2253 || (_rect2253 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2254 || (_rect2254 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2255 || (_rect2255 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2256 || (_rect2256 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2257 || (_rect2257 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2258 || (_rect2258 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2259 || (_rect2259 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2260 || (_rect2260 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2261 || (_rect2261 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2262 || (_rect2262 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2263 || (_rect2263 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2264 || (_rect2264 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2265 || (_rect2265 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2266 || (_rect2266 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2267 || (_rect2267 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2268 || (_rect2268 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2269 || (_rect2269 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2270 || (_rect2270 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2271 || (_rect2271 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2272 || (_rect2272 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2273 || (_rect2273 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2274 || (_rect2274 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 41,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2275 || (_rect2275 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 42,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2276 || (_rect2276 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 42,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2277 || (_rect2277 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 42,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2278 || (_rect2278 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 42,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2279 || (_rect2279 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 42,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2280 || (_rect2280 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 42,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2281 || (_rect2281 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 42,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2282 || (_rect2282 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 42,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2283 || (_rect2283 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 42,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2284 || (_rect2284 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 42,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2285 || (_rect2285 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 42,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2286 || (_rect2286 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 42,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2287 || (_rect2287 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 42,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2288 || (_rect2288 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 42,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2289 || (_rect2289 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 42,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2290 || (_rect2290 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 42,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2291 || (_rect2291 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 42,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2292 || (_rect2292 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 42,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2293 || (_rect2293 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 42,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2294 || (_rect2294 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 42,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2295 || (_rect2295 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 42,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2296 || (_rect2296 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 42,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2297 || (_rect2297 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 42,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2298 || (_rect2298 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 42,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2299 || (_rect2299 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 42,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2300 || (_rect2300 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 42,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2301 || (_rect2301 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 42,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2302 || (_rect2302 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 42,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2303 || (_rect2303 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 42,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2304 || (_rect2304 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 42,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2305 || (_rect2305 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 42,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2306 || (_rect2306 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 42,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2307 || (_rect2307 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 42,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2308 || (_rect2308 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 42,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2309 || (_rect2309 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 42,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2310 || (_rect2310 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 42,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2311 || (_rect2311 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 42,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2312 || (_rect2312 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 42,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2313 || (_rect2313 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 42,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2314 || (_rect2314 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 42,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2315 || (_rect2315 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 42,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2316 || (_rect2316 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 42,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2317 || (_rect2317 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 42,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2318 || (_rect2318 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 42,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2319 || (_rect2319 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 42,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2320 || (_rect2320 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 42,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2321 || (_rect2321 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 42,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2322 || (_rect2322 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 42,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2323 || (_rect2323 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 42,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2324 || (_rect2324 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 42,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2325 || (_rect2325 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 42,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2326 || (_rect2326 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 42,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2327 || (_rect2327 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 42,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2328 || (_rect2328 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 42,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2329 || (_rect2329 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 42,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2330 || (_rect2330 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 42,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2331 || (_rect2331 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 42,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2332 || (_rect2332 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 42,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2333 || (_rect2333 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 42,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2334 || (_rect2334 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 42,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2335 || (_rect2335 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 42,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2336 || (_rect2336 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 43,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2337 || (_rect2337 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 43,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2338 || (_rect2338 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 43,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2339 || (_rect2339 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 43,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2340 || (_rect2340 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 43,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2341 || (_rect2341 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 43,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2342 || (_rect2342 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 43,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2343 || (_rect2343 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 43,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2344 || (_rect2344 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 43,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2345 || (_rect2345 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 43,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2346 || (_rect2346 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 43,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2347 || (_rect2347 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 43,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2348 || (_rect2348 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 43,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2349 || (_rect2349 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 43,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2350 || (_rect2350 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 43,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2351 || (_rect2351 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 43,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2352 || (_rect2352 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 43,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2353 || (_rect2353 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 43,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2354 || (_rect2354 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 43,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2355 || (_rect2355 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 43,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2356 || (_rect2356 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 43,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2357 || (_rect2357 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 43,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2358 || (_rect2358 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 43,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2359 || (_rect2359 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 43,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2360 || (_rect2360 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 43,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2361 || (_rect2361 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 43,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2362 || (_rect2362 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 43,
    width: 1,
    height: 1,
    fill: "#517968"
  })), _rect2363 || (_rect2363 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 43,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2364 || (_rect2364 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 43,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2365 || (_rect2365 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 43,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2366 || (_rect2366 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 43,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2367 || (_rect2367 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 43,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2368 || (_rect2368 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 43,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2369 || (_rect2369 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 43,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2370 || (_rect2370 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 43,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2371 || (_rect2371 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 43,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2372 || (_rect2372 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 43,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2373 || (_rect2373 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 43,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2374 || (_rect2374 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 43,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2375 || (_rect2375 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 43,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2376 || (_rect2376 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 43,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2377 || (_rect2377 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 43,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2378 || (_rect2378 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 43,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2379 || (_rect2379 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 43,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2380 || (_rect2380 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 43,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2381 || (_rect2381 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 43,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2382 || (_rect2382 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 43,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2383 || (_rect2383 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 43,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2384 || (_rect2384 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 43,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2385 || (_rect2385 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 43,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2386 || (_rect2386 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 43,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2387 || (_rect2387 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 43,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2388 || (_rect2388 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 43,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2389 || (_rect2389 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 43,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2390 || (_rect2390 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 43,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2391 || (_rect2391 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 43,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2392 || (_rect2392 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 43,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2393 || (_rect2393 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 43,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2394 || (_rect2394 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 43,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2395 || (_rect2395 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 43,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2396 || (_rect2396 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 43,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2397 || (_rect2397 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2398 || (_rect2398 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2399 || (_rect2399 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2400 || (_rect2400 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2401 || (_rect2401 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 44,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2402 || (_rect2402 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 44,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2403 || (_rect2403 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 44,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2404 || (_rect2404 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 44,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2405 || (_rect2405 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 44,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2406 || (_rect2406 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 44,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2407 || (_rect2407 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 44,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2408 || (_rect2408 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 44,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2409 || (_rect2409 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 44,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2410 || (_rect2410 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 44,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2411 || (_rect2411 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 44,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2412 || (_rect2412 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 44,
    width: 1,
    height: 1,
    fill: "#5B5BEC"
  })), _rect2413 || (_rect2413 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 44,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2414 || (_rect2414 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 44,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2415 || (_rect2415 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 44,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2416 || (_rect2416 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 44,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2417 || (_rect2417 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 44,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2418 || (_rect2418 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 44,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2419 || (_rect2419 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 44,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2420 || (_rect2420 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 44,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2421 || (_rect2421 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 44,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2422 || (_rect2422 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 44,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2423 || (_rect2423 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 44,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2424 || (_rect2424 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 44,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2425 || (_rect2425 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 44,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2426 || (_rect2426 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 44,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2427 || (_rect2427 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2428 || (_rect2428 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2429 || (_rect2429 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2430 || (_rect2430 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2431 || (_rect2431 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2432 || (_rect2432 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2433 || (_rect2433 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2434 || (_rect2434 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2435 || (_rect2435 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2436 || (_rect2436 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 44,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2437 || (_rect2437 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 44,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2438 || (_rect2438 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 44,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2439 || (_rect2439 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 44,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2440 || (_rect2440 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 44,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2441 || (_rect2441 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 44,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2442 || (_rect2442 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 44,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2443 || (_rect2443 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 44,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2444 || (_rect2444 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 44,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2445 || (_rect2445 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 44,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2446 || (_rect2446 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 44,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2447 || (_rect2447 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 44,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2448 || (_rect2448 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 44,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2449 || (_rect2449 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 44,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2450 || (_rect2450 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2451 || (_rect2451 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2452 || (_rect2452 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2453 || (_rect2453 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2454 || (_rect2454 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2455 || (_rect2455 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2456 || (_rect2456 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2457 || (_rect2457 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2458 || (_rect2458 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 44,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2459 || (_rect2459 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2460 || (_rect2460 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2461 || (_rect2461 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2462 || (_rect2462 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2463 || (_rect2463 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 45,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2464 || (_rect2464 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 45,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2465 || (_rect2465 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 45,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2466 || (_rect2466 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 45,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2467 || (_rect2467 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 45,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2468 || (_rect2468 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2469 || (_rect2469 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2470 || (_rect2470 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2471 || (_rect2471 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 45,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2472 || (_rect2472 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 45,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2473 || (_rect2473 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 45,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2474 || (_rect2474 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 45,
    width: 1,
    height: 1,
    fill: "#5B5BEC"
  })), _rect2475 || (_rect2475 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 45,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2476 || (_rect2476 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 45,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2477 || (_rect2477 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2478 || (_rect2478 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2479 || (_rect2479 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2480 || (_rect2480 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2481 || (_rect2481 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2482 || (_rect2482 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2483 || (_rect2483 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2484 || (_rect2484 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 45,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2485 || (_rect2485 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 45,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2486 || (_rect2486 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 45,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2487 || (_rect2487 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 45,
    width: 1,
    height: 1,
    fill: "#3F645E"
  })), _rect2488 || (_rect2488 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 45,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2489 || (_rect2489 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2490 || (_rect2490 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2491 || (_rect2491 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2492 || (_rect2492 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2493 || (_rect2493 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2494 || (_rect2494 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 45,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2495 || (_rect2495 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 45,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2496 || (_rect2496 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 45,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2497 || (_rect2497 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 45,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2498 || (_rect2498 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 45,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2499 || (_rect2499 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 45,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2500 || (_rect2500 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 45,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2501 || (_rect2501 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 45,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2502 || (_rect2502 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 45,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2503 || (_rect2503 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 45,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2504 || (_rect2504 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 45,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2505 || (_rect2505 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 45,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2506 || (_rect2506 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 45,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2507 || (_rect2507 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 45,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2508 || (_rect2508 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 45,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2509 || (_rect2509 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 45,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2510 || (_rect2510 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 45,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2511 || (_rect2511 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2512 || (_rect2512 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2513 || (_rect2513 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2514 || (_rect2514 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2515 || (_rect2515 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2516 || (_rect2516 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2517 || (_rect2517 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2518 || (_rect2518 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2519 || (_rect2519 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2520 || (_rect2520 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 45,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2521 || (_rect2521 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2522 || (_rect2522 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2523 || (_rect2523 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2524 || (_rect2524 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2525 || (_rect2525 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 46,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2526 || (_rect2526 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 46,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2527 || (_rect2527 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 46,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2528 || (_rect2528 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2529 || (_rect2529 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2530 || (_rect2530 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2531 || (_rect2531 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2532 || (_rect2532 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2533 || (_rect2533 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 46,
    width: 1,
    height: 1,
    fill: "#6128AF"
  })), _rect2534 || (_rect2534 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 46,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2535 || (_rect2535 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 46,
    width: 1,
    height: 1,
    fill: "#5B5BEC"
  })), _rect2536 || (_rect2536 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 46,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2537 || (_rect2537 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 46,
    width: 1,
    height: 1,
    fill: "#6128AF"
  })), _rect2538 || (_rect2538 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2539 || (_rect2539 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2540 || (_rect2540 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2541 || (_rect2541 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2542 || (_rect2542 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2543 || (_rect2543 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2544 || (_rect2544 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2545 || (_rect2545 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2546 || (_rect2546 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 46,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2547 || (_rect2547 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 46,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2548 || (_rect2548 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 46,
    width: 1,
    height: 1,
    fill: "#4A3052"
  })), _rect2549 || (_rect2549 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2550 || (_rect2550 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2551 || (_rect2551 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2552 || (_rect2552 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2553 || (_rect2553 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2554 || (_rect2554 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2555 || (_rect2555 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2556 || (_rect2556 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2557 || (_rect2557 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2558 || (_rect2558 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2559 || (_rect2559 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2560 || (_rect2560 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 46,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2561 || (_rect2561 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 46,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2562 || (_rect2562 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 46,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2563 || (_rect2563 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 46,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2564 || (_rect2564 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 46,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2565 || (_rect2565 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 46,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2566 || (_rect2566 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 46,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2567 || (_rect2567 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 46,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2568 || (_rect2568 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 46,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2569 || (_rect2569 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 46,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2570 || (_rect2570 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 46,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2571 || (_rect2571 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 46,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2572 || (_rect2572 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 46,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2573 || (_rect2573 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 46,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2574 || (_rect2574 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 46,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2575 || (_rect2575 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2576 || (_rect2576 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2577 || (_rect2577 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2578 || (_rect2578 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2579 || (_rect2579 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2580 || (_rect2580 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2581 || (_rect2581 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 46,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2582 || (_rect2582 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2583 || (_rect2583 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2584 || (_rect2584 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2585 || (_rect2585 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2586 || (_rect2586 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2587 || (_rect2587 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2588 || (_rect2588 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2589 || (_rect2589 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2590 || (_rect2590 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2591 || (_rect2591 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2592 || (_rect2592 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2593 || (_rect2593 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2594 || (_rect2594 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 47,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2595 || (_rect2595 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 47,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2596 || (_rect2596 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 47,
    width: 1,
    height: 1,
    fill: "#5B5BEC"
  })), _rect2597 || (_rect2597 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2598 || (_rect2598 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2599 || (_rect2599 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2600 || (_rect2600 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2601 || (_rect2601 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2602 || (_rect2602 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2603 || (_rect2603 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2604 || (_rect2604 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2605 || (_rect2605 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2606 || (_rect2606 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2607 || (_rect2607 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2608 || (_rect2608 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2609 || (_rect2609 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2610 || (_rect2610 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2611 || (_rect2611 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2612 || (_rect2612 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2613 || (_rect2613 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2614 || (_rect2614 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2615 || (_rect2615 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2616 || (_rect2616 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2617 || (_rect2617 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2618 || (_rect2618 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2619 || (_rect2619 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2620 || (_rect2620 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 47,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2621 || (_rect2621 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 47,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2622 || (_rect2622 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 47,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2623 || (_rect2623 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 47,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2624 || (_rect2624 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 47,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2625 || (_rect2625 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 47,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2626 || (_rect2626 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 47,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2627 || (_rect2627 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2628 || (_rect2628 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2629 || (_rect2629 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2630 || (_rect2630 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2631 || (_rect2631 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2632 || (_rect2632 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2633 || (_rect2633 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2634 || (_rect2634 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2635 || (_rect2635 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2636 || (_rect2636 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2637 || (_rect2637 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2638 || (_rect2638 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2639 || (_rect2639 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 47,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2640 || (_rect2640 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2641 || (_rect2641 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2642 || (_rect2642 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2643 || (_rect2643 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2644 || (_rect2644 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2645 || (_rect2645 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2646 || (_rect2646 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2647 || (_rect2647 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2648 || (_rect2648 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2649 || (_rect2649 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2650 || (_rect2650 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2651 || (_rect2651 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2652 || (_rect2652 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 48,
    width: 1,
    height: 1,
    fill: "#6646DE"
  })), _rect2653 || (_rect2653 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 48,
    width: 1,
    height: 1,
    fill: "#6128AF"
  })), _rect2654 || (_rect2654 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 48,
    width: 1,
    height: 1,
    fill: "#6128AF"
  })), _rect2655 || (_rect2655 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 48,
    width: 1,
    height: 1,
    fill: "#6128AF"
  })), _rect2656 || (_rect2656 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 48,
    width: 1,
    height: 1,
    fill: "#5B5BEC"
  })), _rect2657 || (_rect2657 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2658 || (_rect2658 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2659 || (_rect2659 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2660 || (_rect2660 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2661 || (_rect2661 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2662 || (_rect2662 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2663 || (_rect2663 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2664 || (_rect2664 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2665 || (_rect2665 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2666 || (_rect2666 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2667 || (_rect2667 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2668 || (_rect2668 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 48,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect2669 || (_rect2669 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2670 || (_rect2670 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2671 || (_rect2671 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2672 || (_rect2672 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2673 || (_rect2673 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2674 || (_rect2674 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2675 || (_rect2675 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2676 || (_rect2676 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2677 || (_rect2677 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2678 || (_rect2678 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2679 || (_rect2679 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2680 || (_rect2680 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2681 || (_rect2681 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 48,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2682 || (_rect2682 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 48,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2683 || (_rect2683 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 48,
    width: 1,
    height: 1,
    fill: "#A6859F"
  })), _rect2684 || (_rect2684 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2685 || (_rect2685 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2686 || (_rect2686 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2687 || (_rect2687 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2688 || (_rect2688 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2689 || (_rect2689 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2690 || (_rect2690 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2691 || (_rect2691 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2692 || (_rect2692 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2693 || (_rect2693 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2694 || (_rect2694 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2695 || (_rect2695 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2696 || (_rect2696 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2697 || (_rect2697 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 48,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect2698 || (_rect2698 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 48,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2699 || (_rect2699 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2700 || (_rect2700 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2701 || (_rect2701 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2702 || (_rect2702 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2703 || (_rect2703 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2704 || (_rect2704 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2705 || (_rect2705 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2706 || (_rect2706 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2707 || (_rect2707 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2708 || (_rect2708 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2709 || (_rect2709 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2710 || (_rect2710 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2711 || (_rect2711 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2712 || (_rect2712 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 49,
    width: 1,
    height: 1,
    fill: "#6128AF"
  })), _rect2713 || (_rect2713 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2714 || (_rect2714 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2715 || (_rect2715 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2716 || (_rect2716 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 49,
    width: 1,
    height: 1,
    fill: "#6128AF"
  })), _rect2717 || (_rect2717 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2718 || (_rect2718 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2719 || (_rect2719 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2720 || (_rect2720 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2721 || (_rect2721 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2722 || (_rect2722 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2723 || (_rect2723 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2724 || (_rect2724 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2725 || (_rect2725 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2726 || (_rect2726 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2727 || (_rect2727 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2728 || (_rect2728 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 49,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect2729 || (_rect2729 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2730 || (_rect2730 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2731 || (_rect2731 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2732 || (_rect2732 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2733 || (_rect2733 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2734 || (_rect2734 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2735 || (_rect2735 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2736 || (_rect2736 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2737 || (_rect2737 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2738 || (_rect2738 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2739 || (_rect2739 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2740 || (_rect2740 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2741 || (_rect2741 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2742 || (_rect2742 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2743 || (_rect2743 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2744 || (_rect2744 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2745 || (_rect2745 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2746 || (_rect2746 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2747 || (_rect2747 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2748 || (_rect2748 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2749 || (_rect2749 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2750 || (_rect2750 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2751 || (_rect2751 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2752 || (_rect2752 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2753 || (_rect2753 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2754 || (_rect2754 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2755 || (_rect2755 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2756 || (_rect2756 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2757 || (_rect2757 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 49,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2758 || (_rect2758 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 49,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2759 || (_rect2759 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2760 || (_rect2760 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2761 || (_rect2761 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2762 || (_rect2762 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2763 || (_rect2763 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2764 || (_rect2764 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2765 || (_rect2765 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2766 || (_rect2766 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2767 || (_rect2767 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2768 || (_rect2768 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2769 || (_rect2769 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2770 || (_rect2770 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2771 || (_rect2771 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2772 || (_rect2772 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2773 || (_rect2773 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2774 || (_rect2774 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2775 || (_rect2775 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2776 || (_rect2776 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2777 || (_rect2777 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2778 || (_rect2778 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2779 || (_rect2779 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2780 || (_rect2780 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2781 || (_rect2781 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2782 || (_rect2782 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2783 || (_rect2783 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2784 || (_rect2784 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2785 || (_rect2785 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2786 || (_rect2786 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2787 || (_rect2787 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2788 || (_rect2788 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2789 || (_rect2789 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 50,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect2790 || (_rect2790 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 50,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2791 || (_rect2791 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 50,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2792 || (_rect2792 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 50,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2793 || (_rect2793 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 50,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2794 || (_rect2794 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 50,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2795 || (_rect2795 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 50,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2796 || (_rect2796 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 50,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2797 || (_rect2797 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 50,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2798 || (_rect2798 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 50,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2799 || (_rect2799 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 50,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2800 || (_rect2800 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 50,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2801 || (_rect2801 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 50,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2802 || (_rect2802 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 50,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2803 || (_rect2803 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 50,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2804 || (_rect2804 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 50,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2805 || (_rect2805 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 50,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2806 || (_rect2806 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 50,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2807 || (_rect2807 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 50,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2808 || (_rect2808 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2809 || (_rect2809 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 50,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2810 || (_rect2810 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 50,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2811 || (_rect2811 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 50,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2812 || (_rect2812 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 50,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2813 || (_rect2813 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 50,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2814 || (_rect2814 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 50,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2815 || (_rect2815 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 50,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2816 || (_rect2816 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 50,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2817 || (_rect2817 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2818 || (_rect2818 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 50,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2819 || (_rect2819 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2820 || (_rect2820 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2821 || (_rect2821 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2822 || (_rect2822 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2823 || (_rect2823 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2824 || (_rect2824 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2825 || (_rect2825 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2826 || (_rect2826 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2827 || (_rect2827 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2828 || (_rect2828 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2829 || (_rect2829 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2830 || (_rect2830 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2831 || (_rect2831 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2832 || (_rect2832 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2833 || (_rect2833 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2834 || (_rect2834 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2835 || (_rect2835 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2836 || (_rect2836 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2837 || (_rect2837 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2838 || (_rect2838 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2839 || (_rect2839 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2840 || (_rect2840 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2841 || (_rect2841 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2842 || (_rect2842 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2843 || (_rect2843 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2844 || (_rect2844 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2845 || (_rect2845 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2846 || (_rect2846 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2847 || (_rect2847 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2848 || (_rect2848 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2849 || (_rect2849 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 51,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2850 || (_rect2850 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 51,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2851 || (_rect2851 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 51,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2852 || (_rect2852 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 51,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2853 || (_rect2853 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 51,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2854 || (_rect2854 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 51,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2855 || (_rect2855 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 51,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2856 || (_rect2856 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 51,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2857 || (_rect2857 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 51,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2858 || (_rect2858 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 51,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2859 || (_rect2859 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 51,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2860 || (_rect2860 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 51,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2861 || (_rect2861 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 51,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2862 || (_rect2862 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 51,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2863 || (_rect2863 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 51,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2864 || (_rect2864 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 51,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2865 || (_rect2865 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 51,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2866 || (_rect2866 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 51,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2867 || (_rect2867 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 51,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2868 || (_rect2868 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 51,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2869 || (_rect2869 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 51,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2870 || (_rect2870 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 51,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2871 || (_rect2871 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 51,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2872 || (_rect2872 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 51,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2873 || (_rect2873 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 51,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2874 || (_rect2874 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 51,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect2875 || (_rect2875 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 51,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2876 || (_rect2876 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 51,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2877 || (_rect2877 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2878 || (_rect2878 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 51,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2879 || (_rect2879 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2880 || (_rect2880 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2881 || (_rect2881 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2882 || (_rect2882 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2883 || (_rect2883 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2884 || (_rect2884 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2885 || (_rect2885 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2886 || (_rect2886 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2887 || (_rect2887 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2888 || (_rect2888 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2889 || (_rect2889 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2890 || (_rect2890 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2891 || (_rect2891 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2892 || (_rect2892 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2893 || (_rect2893 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2894 || (_rect2894 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2895 || (_rect2895 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2896 || (_rect2896 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2897 || (_rect2897 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2898 || (_rect2898 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2899 || (_rect2899 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2900 || (_rect2900 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2901 || (_rect2901 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2902 || (_rect2902 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2903 || (_rect2903 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2904 || (_rect2904 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2905 || (_rect2905 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2906 || (_rect2906 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2907 || (_rect2907 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2908 || (_rect2908 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 52,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2909 || (_rect2909 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 52,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2910 || (_rect2910 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 52,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2911 || (_rect2911 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 52,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect2912 || (_rect2912 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 52,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect2913 || (_rect2913 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 52,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect2914 || (_rect2914 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 52,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2915 || (_rect2915 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 52,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2916 || (_rect2916 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 52,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect2917 || (_rect2917 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 52,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2918 || (_rect2918 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 52,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2919 || (_rect2919 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 52,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2920 || (_rect2920 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 52,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2921 || (_rect2921 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 52,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2922 || (_rect2922 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 52,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2923 || (_rect2923 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 52,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2924 || (_rect2924 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 52,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2925 || (_rect2925 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 52,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2926 || (_rect2926 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 52,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2927 || (_rect2927 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 52,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2928 || (_rect2928 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 52,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2929 || (_rect2929 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 52,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2930 || (_rect2930 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 52,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2931 || (_rect2931 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 52,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2932 || (_rect2932 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 52,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2933 || (_rect2933 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 52,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2934 || (_rect2934 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 52,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect2935 || (_rect2935 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 52,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2936 || (_rect2936 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2937 || (_rect2937 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2938 || (_rect2938 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 52,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2939 || (_rect2939 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2940 || (_rect2940 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2941 || (_rect2941 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2942 || (_rect2942 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2943 || (_rect2943 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2944 || (_rect2944 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2945 || (_rect2945 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2946 || (_rect2946 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2947 || (_rect2947 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2948 || (_rect2948 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2949 || (_rect2949 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2950 || (_rect2950 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2951 || (_rect2951 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2952 || (_rect2952 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2953 || (_rect2953 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2954 || (_rect2954 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2955 || (_rect2955 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2956 || (_rect2956 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2957 || (_rect2957 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2958 || (_rect2958 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2959 || (_rect2959 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2960 || (_rect2960 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2961 || (_rect2961 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2962 || (_rect2962 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2963 || (_rect2963 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2964 || (_rect2964 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2965 || (_rect2965 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 53,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2966 || (_rect2966 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 53,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2967 || (_rect2967 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 53,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2968 || (_rect2968 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 53,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2969 || (_rect2969 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 53,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2970 || (_rect2970 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 53,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2971 || (_rect2971 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 53,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2972 || (_rect2972 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 53,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2973 || (_rect2973 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 53,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2974 || (_rect2974 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 53,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect2975 || (_rect2975 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 53,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2976 || (_rect2976 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 53,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2977 || (_rect2977 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 53,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2978 || (_rect2978 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 53,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2979 || (_rect2979 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 53,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2980 || (_rect2980 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 53,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2981 || (_rect2981 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 53,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2982 || (_rect2982 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 53,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2983 || (_rect2983 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 53,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2984 || (_rect2984 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 53,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2985 || (_rect2985 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 53,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2986 || (_rect2986 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 53,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2987 || (_rect2987 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 53,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2988 || (_rect2988 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 53,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2989 || (_rect2989 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 53,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2990 || (_rect2990 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 53,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2991 || (_rect2991 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 53,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect2992 || (_rect2992 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 53,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect2993 || (_rect2993 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2994 || (_rect2994 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2995 || (_rect2995 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 53,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2996 || (_rect2996 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2997 || (_rect2997 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2998 || (_rect2998 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect2999 || (_rect2999 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3000 || (_rect3000 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3001 || (_rect3001 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3002 || (_rect3002 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3003 || (_rect3003 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3004 || (_rect3004 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3005 || (_rect3005 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3006 || (_rect3006 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3007 || (_rect3007 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3008 || (_rect3008 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3009 || (_rect3009 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3010 || (_rect3010 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3011 || (_rect3011 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3012 || (_rect3012 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3013 || (_rect3013 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3014 || (_rect3014 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3015 || (_rect3015 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3016 || (_rect3016 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3017 || (_rect3017 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3018 || (_rect3018 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3019 || (_rect3019 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3020 || (_rect3020 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3021 || (_rect3021 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3022 || (_rect3022 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3023 || (_rect3023 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3024 || (_rect3024 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 54,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3025 || (_rect3025 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 54,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3026 || (_rect3026 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 54,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3027 || (_rect3027 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 54,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3028 || (_rect3028 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 54,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3029 || (_rect3029 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 54,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3030 || (_rect3030 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 54,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3031 || (_rect3031 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 54,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3032 || (_rect3032 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 54,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3033 || (_rect3033 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 54,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3034 || (_rect3034 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 54,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3035 || (_rect3035 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 54,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect3036 || (_rect3036 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 54,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3037 || (_rect3037 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 54,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3038 || (_rect3038 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 54,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3039 || (_rect3039 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 54,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3040 || (_rect3040 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 54,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3041 || (_rect3041 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 54,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3042 || (_rect3042 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 54,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3043 || (_rect3043 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 54,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3044 || (_rect3044 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 54,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3045 || (_rect3045 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 54,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3046 || (_rect3046 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 54,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3047 || (_rect3047 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 54,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3048 || (_rect3048 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 54,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3049 || (_rect3049 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 54,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3050 || (_rect3050 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 54,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3051 || (_rect3051 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 54,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3052 || (_rect3052 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3053 || (_rect3053 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3054 || (_rect3054 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 54,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3055 || (_rect3055 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3056 || (_rect3056 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3057 || (_rect3057 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3058 || (_rect3058 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3059 || (_rect3059 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3060 || (_rect3060 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3061 || (_rect3061 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3062 || (_rect3062 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3063 || (_rect3063 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3064 || (_rect3064 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3065 || (_rect3065 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3066 || (_rect3066 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3067 || (_rect3067 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3068 || (_rect3068 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3069 || (_rect3069 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3070 || (_rect3070 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3071 || (_rect3071 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3072 || (_rect3072 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3073 || (_rect3073 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3074 || (_rect3074 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3075 || (_rect3075 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3076 || (_rect3076 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3077 || (_rect3077 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3078 || (_rect3078 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3079 || (_rect3079 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3080 || (_rect3080 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3081 || (_rect3081 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3082 || (_rect3082 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3083 || (_rect3083 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3084 || (_rect3084 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 55,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3085 || (_rect3085 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 55,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3086 || (_rect3086 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 55,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3087 || (_rect3087 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 55,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3088 || (_rect3088 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 55,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3089 || (_rect3089 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 55,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3090 || (_rect3090 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 55,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3091 || (_rect3091 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 55,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3092 || (_rect3092 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 55,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3093 || (_rect3093 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 55,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3094 || (_rect3094 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 55,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3095 || (_rect3095 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 55,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect3096 || (_rect3096 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 55,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3097 || (_rect3097 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 55,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3098 || (_rect3098 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 55,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3099 || (_rect3099 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 55,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3100 || (_rect3100 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 55,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3101 || (_rect3101 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 55,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3102 || (_rect3102 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 55,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3103 || (_rect3103 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 55,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3104 || (_rect3104 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 55,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3105 || (_rect3105 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 55,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3106 || (_rect3106 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 55,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3107 || (_rect3107 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 55,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3108 || (_rect3108 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 55,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3109 || (_rect3109 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 55,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3110 || (_rect3110 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 55,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3111 || (_rect3111 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 55,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3112 || (_rect3112 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3113 || (_rect3113 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3114 || (_rect3114 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3115 || (_rect3115 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 55,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3116 || (_rect3116 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3117 || (_rect3117 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3118 || (_rect3118 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3119 || (_rect3119 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3120 || (_rect3120 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3121 || (_rect3121 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3122 || (_rect3122 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3123 || (_rect3123 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3124 || (_rect3124 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3125 || (_rect3125 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3126 || (_rect3126 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3127 || (_rect3127 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3128 || (_rect3128 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3129 || (_rect3129 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3130 || (_rect3130 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3131 || (_rect3131 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3132 || (_rect3132 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3133 || (_rect3133 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3134 || (_rect3134 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3135 || (_rect3135 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3136 || (_rect3136 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3137 || (_rect3137 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3138 || (_rect3138 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3139 || (_rect3139 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3140 || (_rect3140 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3141 || (_rect3141 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3142 || (_rect3142 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3143 || (_rect3143 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3144 || (_rect3144 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3145 || (_rect3145 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3146 || (_rect3146 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 56,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3147 || (_rect3147 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 56,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3148 || (_rect3148 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 56,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3149 || (_rect3149 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 56,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3150 || (_rect3150 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 56,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3151 || (_rect3151 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 56,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3152 || (_rect3152 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 56,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3153 || (_rect3153 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 56,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3154 || (_rect3154 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 56,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3155 || (_rect3155 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 56,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3156 || (_rect3156 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 56,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3157 || (_rect3157 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 56,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3158 || (_rect3158 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 56,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect3159 || (_rect3159 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 56,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3160 || (_rect3160 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 56,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3161 || (_rect3161 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 56,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3162 || (_rect3162 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 56,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3163 || (_rect3163 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 56,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3164 || (_rect3164 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 56,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3165 || (_rect3165 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 56,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3166 || (_rect3166 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 56,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3167 || (_rect3167 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 56,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3168 || (_rect3168 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 56,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3169 || (_rect3169 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 56,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3170 || (_rect3170 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 56,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3171 || (_rect3171 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 56,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect3172 || (_rect3172 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 56,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3173 || (_rect3173 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 56,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3174 || (_rect3174 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3175 || (_rect3175 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3176 || (_rect3176 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3177 || (_rect3177 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 56,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3178 || (_rect3178 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3179 || (_rect3179 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3180 || (_rect3180 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3181 || (_rect3181 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3182 || (_rect3182 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3183 || (_rect3183 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3184 || (_rect3184 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3185 || (_rect3185 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3186 || (_rect3186 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3187 || (_rect3187 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3188 || (_rect3188 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3189 || (_rect3189 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3190 || (_rect3190 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3191 || (_rect3191 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3192 || (_rect3192 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3193 || (_rect3193 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3194 || (_rect3194 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3195 || (_rect3195 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3196 || (_rect3196 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3197 || (_rect3197 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3198 || (_rect3198 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3199 || (_rect3199 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3200 || (_rect3200 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3201 || (_rect3201 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3202 || (_rect3202 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3203 || (_rect3203 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3204 || (_rect3204 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3205 || (_rect3205 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3206 || (_rect3206 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3207 || (_rect3207 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3208 || (_rect3208 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 57,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3209 || (_rect3209 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 57,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3210 || (_rect3210 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 57,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3211 || (_rect3211 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 57,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3212 || (_rect3212 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 57,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3213 || (_rect3213 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 57,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3214 || (_rect3214 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 57,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3215 || (_rect3215 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 57,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3216 || (_rect3216 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 57,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3217 || (_rect3217 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 57,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3218 || (_rect3218 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 57,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3219 || (_rect3219 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 57,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3220 || (_rect3220 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 57,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3221 || (_rect3221 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 57,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3222 || (_rect3222 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 57,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3223 || (_rect3223 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 57,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3224 || (_rect3224 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 57,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3225 || (_rect3225 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 57,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3226 || (_rect3226 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 57,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3227 || (_rect3227 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 57,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3228 || (_rect3228 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 57,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3229 || (_rect3229 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 57,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3230 || (_rect3230 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 57,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect3231 || (_rect3231 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 57,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect3232 || (_rect3232 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 57,
    width: 1,
    height: 1,
    fill: "#EA6262"
  })), _rect3233 || (_rect3233 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 57,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3234 || (_rect3234 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 57,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3235 || (_rect3235 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 57,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3236 || (_rect3236 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3237 || (_rect3237 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3238 || (_rect3238 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 57,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3239 || (_rect3239 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3240 || (_rect3240 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3241 || (_rect3241 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3242 || (_rect3242 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3243 || (_rect3243 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3244 || (_rect3244 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3245 || (_rect3245 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3246 || (_rect3246 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3247 || (_rect3247 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3248 || (_rect3248 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3249 || (_rect3249 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3250 || (_rect3250 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3251 || (_rect3251 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3252 || (_rect3252 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3253 || (_rect3253 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3254 || (_rect3254 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3255 || (_rect3255 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3256 || (_rect3256 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3257 || (_rect3257 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3258 || (_rect3258 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3259 || (_rect3259 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3260 || (_rect3260 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3261 || (_rect3261 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3262 || (_rect3262 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3263 || (_rect3263 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3264 || (_rect3264 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3265 || (_rect3265 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3266 || (_rect3266 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3267 || (_rect3267 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3268 || (_rect3268 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3269 || (_rect3269 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 58,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3270 || (_rect3270 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 58,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3271 || (_rect3271 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 58,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3272 || (_rect3272 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 58,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3273 || (_rect3273 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 58,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3274 || (_rect3274 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 58,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3275 || (_rect3275 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 58,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3276 || (_rect3276 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 58,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3277 || (_rect3277 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 58,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3278 || (_rect3278 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 58,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3279 || (_rect3279 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 58,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3280 || (_rect3280 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 58,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3281 || (_rect3281 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 58,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3282 || (_rect3282 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 58,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3283 || (_rect3283 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 58,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3284 || (_rect3284 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 58,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3285 || (_rect3285 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 58,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3286 || (_rect3286 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 58,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3287 || (_rect3287 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 58,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3288 || (_rect3288 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 58,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3289 || (_rect3289 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 58,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3290 || (_rect3290 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 58,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3291 || (_rect3291 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 58,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3292 || (_rect3292 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 58,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3293 || (_rect3293 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 58,
    width: 1,
    height: 1,
    fill: "#A32858"
  })), _rect3294 || (_rect3294 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 58,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3295 || (_rect3295 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 58,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3296 || (_rect3296 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 58,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3297 || (_rect3297 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3298 || (_rect3298 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 58,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3299 || (_rect3299 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3300 || (_rect3300 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3301 || (_rect3301 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3302 || (_rect3302 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3303 || (_rect3303 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3304 || (_rect3304 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3305 || (_rect3305 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3306 || (_rect3306 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3307 || (_rect3307 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3308 || (_rect3308 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3309 || (_rect3309 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3310 || (_rect3310 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3311 || (_rect3311 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3312 || (_rect3312 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3313 || (_rect3313 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3314 || (_rect3314 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3315 || (_rect3315 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3316 || (_rect3316 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3317 || (_rect3317 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3318 || (_rect3318 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3319 || (_rect3319 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3320 || (_rect3320 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3321 || (_rect3321 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3322 || (_rect3322 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3323 || (_rect3323 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3324 || (_rect3324 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3325 || (_rect3325 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3326 || (_rect3326 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3327 || (_rect3327 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3328 || (_rect3328 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 59,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3329 || (_rect3329 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3330 || (_rect3330 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3331 || (_rect3331 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3332 || (_rect3332 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3333 || (_rect3333 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3334 || (_rect3334 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3335 || (_rect3335 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3336 || (_rect3336 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3337 || (_rect3337 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3338 || (_rect3338 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3339 || (_rect3339 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3340 || (_rect3340 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3341 || (_rect3341 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3342 || (_rect3342 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3343 || (_rect3343 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3344 || (_rect3344 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3345 || (_rect3345 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3346 || (_rect3346 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3347 || (_rect3347 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3348 || (_rect3348 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3349 || (_rect3349 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3350 || (_rect3350 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3351 || (_rect3351 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3352 || (_rect3352 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3353 || (_rect3353 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3354 || (_rect3354 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3355 || (_rect3355 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3356 || (_rect3356 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 59,
    width: 1,
    height: 1,
    fill: "#751756"
  })), _rect3357 || (_rect3357 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 59,
    width: 1,
    height: 1,
    fill: "#CC425E"
  })), _rect3358 || (_rect3358 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 59,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3359 || (_rect3359 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3360 || (_rect3360 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3361 || (_rect3361 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3362 || (_rect3362 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3363 || (_rect3363 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3364 || (_rect3364 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3365 || (_rect3365 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3366 || (_rect3366 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3367 || (_rect3367 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3368 || (_rect3368 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3369 || (_rect3369 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3370 || (_rect3370 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3371 || (_rect3371 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3372 || (_rect3372 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3373 || (_rect3373 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3374 || (_rect3374 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3375 || (_rect3375 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3376 || (_rect3376 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3377 || (_rect3377 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3378 || (_rect3378 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3379 || (_rect3379 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3380 || (_rect3380 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3381 || (_rect3381 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3382 || (_rect3382 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3383 || (_rect3383 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3384 || (_rect3384 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3385 || (_rect3385 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3386 || (_rect3386 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3387 || (_rect3387 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3388 || (_rect3388 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3389 || (_rect3389 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3390 || (_rect3390 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3391 || (_rect3391 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3392 || (_rect3392 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3393 || (_rect3393 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3394 || (_rect3394 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3395 || (_rect3395 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3396 || (_rect3396 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3397 || (_rect3397 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3398 || (_rect3398 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3399 || (_rect3399 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3400 || (_rect3400 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3401 || (_rect3401 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3402 || (_rect3402 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3403 || (_rect3403 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3404 || (_rect3404 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3405 || (_rect3405 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3406 || (_rect3406 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3407 || (_rect3407 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3408 || (_rect3408 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3409 || (_rect3409 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3410 || (_rect3410 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3411 || (_rect3411 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3412 || (_rect3412 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3413 || (_rect3413 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3414 || (_rect3414 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3415 || (_rect3415 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 60,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3416 || (_rect3416 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3417 || (_rect3417 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3418 || (_rect3418 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3419 || (_rect3419 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3420 || (_rect3420 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3421 || (_rect3421 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3422 || (_rect3422 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3423 || (_rect3423 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3424 || (_rect3424 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3425 || (_rect3425 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3426 || (_rect3426 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3427 || (_rect3427 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3428 || (_rect3428 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3429 || (_rect3429 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3430 || (_rect3430 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3431 || (_rect3431 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3432 || (_rect3432 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3433 || (_rect3433 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3434 || (_rect3434 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3435 || (_rect3435 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3436 || (_rect3436 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3437 || (_rect3437 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3438 || (_rect3438 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3439 || (_rect3439 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3440 || (_rect3440 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3441 || (_rect3441 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3442 || (_rect3442 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3443 || (_rect3443 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3444 || (_rect3444 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3445 || (_rect3445 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3446 || (_rect3446 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3447 || (_rect3447 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3448 || (_rect3448 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3449 || (_rect3449 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3450 || (_rect3450 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3451 || (_rect3451 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3452 || (_rect3452 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3453 || (_rect3453 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3454 || (_rect3454 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3455 || (_rect3455 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3456 || (_rect3456 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3457 || (_rect3457 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3458 || (_rect3458 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3459 || (_rect3459 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3460 || (_rect3460 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3461 || (_rect3461 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3462 || (_rect3462 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3463 || (_rect3463 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3464 || (_rect3464 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3465 || (_rect3465 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3466 || (_rect3466 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3467 || (_rect3467 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 61,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3468 || (_rect3468 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3469 || (_rect3469 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3470 || (_rect3470 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3471 || (_rect3471 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3472 || (_rect3472 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3473 || (_rect3473 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3474 || (_rect3474 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3475 || (_rect3475 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3476 || (_rect3476 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3477 || (_rect3477 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3478 || (_rect3478 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3479 || (_rect3479 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3480 || (_rect3480 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3481 || (_rect3481 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3482 || (_rect3482 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3483 || (_rect3483 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3484 || (_rect3484 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3485 || (_rect3485 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3486 || (_rect3486 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3487 || (_rect3487 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3488 || (_rect3488 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3489 || (_rect3489 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3490 || (_rect3490 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3491 || (_rect3491 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3492 || (_rect3492 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3493 || (_rect3493 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3494 || (_rect3494 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3495 || (_rect3495 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3496 || (_rect3496 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3497 || (_rect3497 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3498 || (_rect3498 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3499 || (_rect3499 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3500 || (_rect3500 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3501 || (_rect3501 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3502 || (_rect3502 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3503 || (_rect3503 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3504 || (_rect3504 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3505 || (_rect3505 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3506 || (_rect3506 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3507 || (_rect3507 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3508 || (_rect3508 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })), _rect3509 || (_rect3509 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 62,
    width: 1,
    height: 1,
    fill: "#7B5480"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCozyHouse);
export default __webpack_public_path__ + "static/media/cozyHouse.a5a5ad9c675a46ad821a105ee399d99c.svg";
export { ForwardRef as ReactComponent };